// AUTO GENERATED
// DO NOT MODIFY

const background = {
  base: {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#202020',
    iosValue: '#FFFFFF',
    iosDarkValue: '#000000',
    androidValue: '#FFFFFF',
    androidDarkValue: '#121212',
    comment: 'Основной фон приложений. Отличается на iOS, Android и Desktop'
  },
  'base-alt': {
    desktopValue: '#F6F7F8',
    desktopDarkValue: '#202020',
    iosValue: '#F6F7F8',
    iosDarkValue: '#333333',
    androidValue: '#F6F7F8',
    androidDarkValue: '#333333',
    comment: 'Альтернативный основной фон, в тёмной теме в вебе равен base'
  },
  'elevation-1': {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#292929',
    iosValue: '#FFFFFF',
    iosDarkValue: '#1C1C1E',
    androidValue: '#FFFFFF',
    androidDarkValue: '#1C1C1E',
    comment: 'Фон шторок, модальных экранов и карточек, лежащих на фоне base'
  },
  'elevation-2': {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#333333',
    iosValue: '#FFFFFF',
    iosDarkValue: '#2C2C2E',
    androidValue: '#FFFFFF',
    androidDarkValue: '#2C2C2E',
    comment: 'Фон карточек, лежащих на фоне elevation-1'
  },
  'elevation-3': {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#525252',
    iosValue: '#FFFFFF',
    iosDarkValue: '#4D4D4D',
    androidValue: '#FFFFFF',
    androidDarkValue: '#4D4D4D',
    comment: 'Фон элементов, возвышающихся над всем остальным контентом. Например, всплывающих подсказок'
  },
  'neutral-1': {
    desktopValue: '#244A7F0F',
    desktopDarkValue: '#FFFFFF1A',
    iosValue: '#00102408',
    iosDarkValue: '#FFFFFF1A',
    androidValue: '#00102408',
    androidDarkValue: '#FFFFFF1A',
    comment: 'Прозрачные контейнеры с минимальным контрастом на фонах base, elevation и neutral. Второстепенные кнопки, карточки без тени, задизейбленные кнопки и т.д.'
  },
  'neutral-1-on-light': {
    desktopValue: '#00000008',
    desktopDarkValue: '#00000008',
    iosValue: '#00000008',
    iosDarkValue: '#00000008',
    androidValue: '#00000008',
    androidDarkValue: '#00000008',
    comment: 'Прозрачные контейнеры с минимальным контрастом на светлых цветных фонах. Не меняется при переключении темы'
  },
  'neutral-1-on-dark': {
    desktopValue: '#FFFFFF1A',
    desktopDarkValue: '#FFFFFF1A',
    iosValue: '#FFFFFF1A',
    iosDarkValue: '#FFFFFF1A',
    androidValue: '#FFFFFF1A',
    androidDarkValue: '#FFFFFF1A',
    comment: 'Прозрачные контейнеры с минимальным контрастом на темных цветных фонах. Не меняется при переключении темы'
  },
  'neutral-1-opaque': {
    desktopValue: '#F6F7F8',
    desktopDarkValue: '#333333',
    iosValue: '#F6F7F8',
    iosDarkValue: '#333333',
    androidValue: '#F6F7F8',
    androidDarkValue: '#333333',
    comment: 'Непрозрачные контейнеры кнопок закрытия и удаления элементов'
  },
  'neutral-1-on-base': {
    desktopValue: '#F6F7F8',
    desktopDarkValue: '#2C2C2E',
    iosValue: '#F6F7F8',
    iosDarkValue: '#1C1C1E',
    androidValue: '#F6F7F8',
    androidDarkValue: '#1C1C1E',
    comment: 'Непрозрачные контейнеры с минимальным контрастом на фоне base, не имеющие тени в светлой теме'
  },
  'neutral-1-on-elevation-1': {
    desktopValue: '#F6F7F8',
    desktopDarkValue: '#2C2C2E',
    iosValue: '#F6F7F8',
    iosDarkValue: '#2C2C2E',
    androidValue: '#F6F7F8',
    androidDarkValue: '#2C2C2E',
    comment: 'Непрозрачные контейнеры с минимальным контрастом на фоне elevation-1, не имеющие тени в светлой теме'
  },
  'neutral-1-hover': {
    desktopValue: '#244A7F17',
    desktopDarkValue: '#FFFFFF26',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Cостояние элементов c фоном neutral-1 при наведении'
  },
  'neutral-1-pressed': {
    desktopValue: '#244A7F1C',
    desktopDarkValue: '#FFFFFF33',
    iosValue: '#0010240F',
    iosDarkValue: '#FFFFFF26',
    androidValue: '#0010240F',
    androidDarkValue: '#FFFFFF26',
    comment: 'Нажатое состояние элементов с фоном neutral-1'
  },
  'neutral-1-hover-on-light': {
    desktopValue: '#0000000f',
    desktopDarkValue: '#0000000f',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Состояние при наведении элементов с фоном neutral-1-on-light, не меняется при переключении темы',
    deprecated: true,
    deprecatedMessage: 'коррекция названия на neutral-1-on-light-hover',
    deprecatedRename: 'neutral-1-on-light-hover'
  },
  'neutral-1-hover-on-dark': {
    desktopValue: '#FFFFFF26',
    desktopDarkValue: '#FFFFFF26',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Состояние при наведении элементов с фоном neutral-1-on-dark, не меняется при переключении темы',
    deprecated: true,
    deprecatedMessage: 'коррекция названия на neutral-1-on-dark-hover',
    deprecatedRename: 'neutral-1-on-dark-hover'
  },
  'neutral-1-on-light-hover': {
    desktopValue: '#0000000f',
    desktopDarkValue: '#0000000f',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Состояние при наведении элементов с фоном neutral-1-on-light, не меняется при переключении темы'
  },
  'neutral-1-on-dark-hover': {
    desktopValue: '#FFFFFF26',
    desktopDarkValue: '#FFFFFF26',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Состояние при наведении элементов с фоном neutral-1-on-dark, не меняется при переключении темы'
  },
  'neutral-1-pressed-on-light': {
    desktopValue: '#0000001F',
    desktopDarkValue: '#0000001F',
    iosValue: '#0000000f',
    iosDarkValue: '#0000000f',
    androidValue: '#0000000f',
    androidDarkValue: '#0000000f',
    comment: 'Нажатое состояние элементов с фоном neutral-1-on-light, не меняется при переключении темы',
    deprecated: true,
    deprecatedMessage: 'коррекция названия на neutral-1-on-light-pressed',
    deprecatedRename: 'neutral-1-on-light-pressed'
  },
  'neutral-1-pressed-on-dark': {
    desktopValue: '#FFFFFF33',
    desktopDarkValue: '#FFFFFF33',
    iosValue: '#FFFFFF26',
    iosDarkValue: '#FFFFFF26',
    androidValue: '#FFFFFF26',
    androidDarkValue: '#FFFFFF26',
    comment: 'Нажатое состояние элементов с фоном neutral-1-on-dark, не меняется при смене темы',
    deprecated: true,
    deprecatedMessage: 'коррекция названия на neutral-1-on-dark-pressed',
    deprecatedRename: 'neutral-1-on-dark-pressed'
  },
  'neutral-1-on-light-pressed': {
    desktopValue: '#0000001F',
    desktopDarkValue: '#0000001F',
    iosValue: '#0000000f',
    iosDarkValue: '#0000000f',
    androidValue: '#0000000f',
    androidDarkValue: '#0000000f',
    comment: 'Нажатое состояние элементов с фоном neutral-1-on-light, не меняется при переключении темы'
  },
  'neutral-1-on-dark-pressed': {
    desktopValue: '#FFFFFF33',
    desktopDarkValue: '#FFFFFF33',
    iosValue: '#FFFFFF26',
    iosDarkValue: '#FFFFFF26',
    androidValue: '#FFFFFF26',
    androidDarkValue: '#FFFFFF26',
    comment: 'Нажатое состояние элементов с фоном neutral-1-on-dark, не меняется при смене темы'
  },
  'neutral-2': {
    desktopValue: '#244A7F14',
    desktopDarkValue: '#FFFFFF26',
    iosValue: '#0010240F',
    iosDarkValue: '#FFFFFF26',
    androidValue: '#0010240F',
    androidDarkValue: '#FFFFFF26',
    comment: 'Прозрачные контейнеры маленьких размеров'
  },
  'neutral-2-hover': {
    desktopValue: '#244A7F1A',
    desktopDarkValue: '#FFFFFF33',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Прозрачные контейнеры со средним контрастом. Нажатое состояние элементов с цветом neutral-2'
  },
  'neutral-2-pressed': {
    desktopValue: '#244A7F1F',
    desktopDarkValue: '#FFFFFF40',
    iosValue: '#0010241F',
    iosDarkValue: '#FFFFFF33',
    androidValue: '#0010241F',
    androidDarkValue: '#FFFFFF33',
    comment: 'Прозрачные контейнеры со средним контрастом. Нажатое состояние элементов с цветом neutral-2'
  },
  'neutral-2-on-light': {
    desktopValue: '#0000000f',
    desktopDarkValue: '#0000000f',
    iosValue: '#0000000f',
    iosDarkValue: '#0000000f',
    androidValue: '#0000000f',
    androidDarkValue: '#0000000f',
    comment: 'Прозрачные контейнеры со слабым контрастом на светлых цветных фонах. Нажатое состояние элементов фоном neutral-1-on-light',
    deprecated: true,
    deprecatedMessage: 'Изменен на neutral-1-pressed-on-light',
    deprecatedRename: 'neutral-1-pressed-on-light'
  },
  'neutral-2-on-dark': {
    desktopValue: '#FFFFFF26',
    desktopDarkValue: '#FFFFFF26',
    iosValue: '#FFFFFF26',
    iosDarkValue: '#FFFFFF26',
    androidValue: '#FFFFFF26',
    androidDarkValue: '#FFFFFF26',
    comment: 'Прозрачные контейнеры со слабым контрастом на темных цветных фонах, не меняется при смене темы'
  },
  'neutral-2-on-dark-hover': {
    desktopValue: '#FFFFFF33',
    desktopDarkValue: '#FFFFFF33',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Прозрачные контейнеры со слабым контрастом на темных цветных фонах, не меняется при смене темы'
  },
  'neutral-2-on-dark-pressed': {
    desktopValue: '#FFFFFF40',
    desktopDarkValue: '#FFFFFF40',
    iosValue: '#FFFFFF33',
    iosDarkValue: '#FFFFFF33',
    androidValue: '#FFFFFF33',
    androidDarkValue: '#FFFFFF33',
    comment: 'Прозрачные контейнеры со слабым контрастом на темных цветных фонах, не меняется при смене темы'
  },
  'neutral-3': {
    desktopValue: '#0010241F',
    desktopDarkValue: '#FFFFFF33',
    iosValue: '#0010241F',
    iosDarkValue: '#FFFFFF33',
    androidValue: '#0010241F',
    androidDarkValue: '#FFFFFF33',
    comment: 'Прозрачные контейнеры со средним контрастом. Нажатое состояние элементов с цветом neutral-2'
  },
  'neutral-3-on-light': {
    desktopValue: '#0000001F',
    desktopDarkValue: '#0000001F',
    iosValue: '#0000001F',
    iosDarkValue: '#0000001F',
    androidValue: '#0000001F',
    androidDarkValue: '#0000001F',
    comment: 'Прозрачные контейнеры со средним контрастом на светлых цветных фонах. Нажатое состояние элементов с цветом neutral-2'
  },
  'neutral-3-on-dark': {
    desktopValue: '#FFFFFF33',
    desktopDarkValue: '#FFFFFF33',
    iosValue: '#FFFFFF33',
    iosDarkValue: '#FFFFFF33',
    androidValue: '#FFFFFF33',
    androidDarkValue: '#FFFFFF33',
    comment: 'Прозрачные контейнеры со средним контрастом на светлых цветных фонах. Нажатое состояние элементов с цветом neutral-2'
  },
  'neutral-4': {
    desktopValue: '#00102438',
    desktopDarkValue: '#FFFFFF4D',
    iosValue: '#00102438',
    iosDarkValue: '#FFFFFF4D',
    androidValue: '#00102438',
    androidDarkValue: '#FFFFFF4D',
    comment: 'Прозрачные контейнеры со средним контрастом. Контейнер аватара с иконкой или текстом'
  },
  'neutral-4-on-light': {
    desktopValue: '#00102438',
    desktopDarkValue: '#00102438',
    iosValue: '#00102438',
    iosDarkValue: '#00102438',
    androidValue: '#00102438',
    androidDarkValue: '#00102438',
    comment: 'Прозрачные контейнеры со средним контрастом на светлых цветных фонах. Контейнер аватара с иконкой или текстом. Нажатое состояние элементов с цветом neutral-3'
  },
  'neutral-4-on-dark': {
    desktopValue: '#FFFFFF4D',
    desktopDarkValue: '#FFFFFF4D',
    iosValue: '#FFFFFF4D',
    iosDarkValue: '#FFFFFF4D',
    androidValue: '#FFFFFF4D',
    androidDarkValue: '#FFFFFF4D',
    comment: 'Прозрачные контейнеры со средним контрастом на темных цветных фонах. Контейнер аватара с иконкой или текстом. Нажатое состояние элементов с цветом neutral-3',
    deprecated: true,
    deprecatedMessage: 'Заменен на overlay-glass-on-dark. Использовался для стеклянных поверхностей',
    deprecatedRename: 'overlay-glass-on-dark'
  },
  'neutral-6': {
    desktopValue: '#0010248F',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#0010248F',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#0010248F',
    androidDarkValue: '#FFFFFF80',
    comment: 'Прозрачные контейнеры с сильным контрастом'
  },
  'neutral-6-on-light': {
    desktopValue: '#00000066',
    desktopDarkValue: '#00000066',
    iosValue: '#00000066',
    iosDarkValue: '#00000066',
    androidValue: '#00000066',
    androidDarkValue: '#00000066',
    comment: 'Прозрачные контейнеры с большим контрастом на светлых цветных фонах',
    deprecated: true,
    deprecatedMessage: 'Заменен на overlay-glass-on-light. Использовался для стеклянных поверхностей.',
    deprecatedRename: 'overlay-glass-on-light'
  },
  'neutral-6-on-dark': {
    desktopValue: '#FFFFFF80',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#FFFFFF80',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#FFFFFF80',
    androidDarkValue: '#FFFFFF80',
    comment: 'Прозрачные контейнеры с большим контрастом на темных цветных фонах'
  },
  opposite: {
    desktopValue: '#000000',
    desktopDarkValue: '#FFFFFF',
    iosValue: '#000000',
    iosDarkValue: '#FFFFFF',
    androidValue: '#000000',
    androidDarkValue: '#FFFFFF',
    comment: 'Фон, противоположный base: в белой теме — черный, в темной теме — белый',
    deprecated: true,
    deprecatedMessage: 'Заменен на accent-opposite',
    deprecatedRename: 'accent-opposite'
  },
  'primary-on-light': {
    desktopValue: '#000000',
    desktopDarkValue: '#000000',
    iosValue: '#000000',
    iosDarkValue: '#000000',
    androidValue: '#000000',
    androidDarkValue: '#000000',
    comment: 'Контрастные контейнеры на светлых фонах',
    deprecated: true,
    deprecatedMessage: 'Заменен на accent-on-light',
    deprecatedRename: 'accent-on-light'
  },
  'primary-on-dark': {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#FFFFFF',
    iosValue: '#FFFFFF',
    iosDarkValue: '#FFFFFF',
    androidValue: '#FFFFFF',
    androidDarkValue: '#FFFFFF',
    comment: 'Контрастные контейнеры на темных фонах',
    deprecated: true,
    deprecatedMessage: 'Заменен на accent-on-dark',
    deprecatedRename: 'accent-on-dark'
  },
  highlight: {
    desktopValue: '#00000014',
    desktopDarkValue: '#FFFFFF1A',
    iosValue: '#00000014',
    iosDarkValue: '#FFFFFF1A',
    androidValue: '#00000014',
    androidDarkValue: '#FFFFFF1A',
    comment: 'Риппл-эффект для элементов с фонами base, elevation, neutral, engaging',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу service'
  },
  'highlight-on-light': {
    desktopValue: '#00000014',
    desktopDarkValue: '#00000014',
    iosValue: '#00000014',
    iosDarkValue: '#00000014',
    androidValue: '#00000014',
    androidDarkValue: '#00000014',
    comment: 'Риппл-эффект для элементов с цветными светлыми фонами',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу service'
  },
  'highlight-on-dark': {
    desktopValue: '#FFFFFF1A',
    desktopDarkValue: '#FFFFFF1A',
    iosValue: '#FFFFFF1A',
    iosDarkValue: '#FFFFFF1A',
    androidValue: '#FFFFFF1A',
    androidDarkValue: '#FFFFFF1A',
    comment: 'Риппл-эффект для элементов с цветными темными фонами',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу service'
  },
  'highlight-on-opposite': {
    desktopValue: '#FFFFFF1A',
    desktopDarkValue: '#00000014',
    iosValue: '#FFFFFF1A',
    iosDarkValue: '#00000014',
    androidValue: '#FFFFFF1A',
    androidDarkValue: '#00000014',
    comment: 'Риппл-эффект для элементов с фоном opposite',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу service'
  },
  'highlight-on-tinkoff': {
    desktopValue: '#FAB61966',
    desktopDarkValue: '#FAB61966',
    iosValue: '#FAB61966',
    iosDarkValue: '#FAB61966',
    androidValue: '#FAB61966',
    androidDarkValue: '#FAB61966',
    comment: 'Риппл на фонах с цветом tinkoff',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу service'
  },
  warning: {
    desktopValue: '#FFDD2D4D',
    desktopDarkValue: '#614F23',
    iosValue: '#FFDD2D4D',
    iosDarkValue: '#614F23',
    androidValue: '#FFDD2D4D',
    androidDarkValue: '#614F23',
    comment: 'Контейнеры предупреждающий нотификаций',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу status',
    deprecatedRename: 'warning-pale'
  },
  'warning-pressed': {
    desktopValue: '#FFDD2D7A',
    desktopDarkValue: '#806925',
    iosValue: '#FFDD2D7A',
    iosDarkValue: '#806925',
    androidValue: '#FFDD2D7A',
    androidDarkValue: '#806925',
    comment: 'Нажатое состояние warning в iOS',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу status',
    deprecatedRename: 'warning-pale-pressed'
  },
  positive: {
    desktopValue: '#00B92D29',
    desktopDarkValue: '#144823',
    iosValue: '#00B92D29',
    iosDarkValue: '#144823',
    androidValue: '#00B92D29',
    androidDarkValue: '#144823',
    comment: 'Контейнеры позитивных нотификаций',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу status',
    deprecatedRename: 'positive-pale'
  },
  'positive-pressed': {
    desktopValue: '#00B92D52',
    desktopDarkValue: '#115B24',
    iosValue: '#00B92D52',
    iosDarkValue: '#115B24',
    androidValue: '#00B92D52',
    androidDarkValue: '#115B24',
    comment: 'Нажатое состояние positive в iOS',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу status',
    deprecatedRename: 'positive-pale-pressed'
  },
  negative: {
    desktopValue: '#F5222224',
    desktopDarkValue: '#591E20',
    iosValue: '#F5222224',
    iosDarkValue: '#591E20',
    androidValue: '#F5222224',
    androidDarkValue: '#591E20',
    comment: 'Контейнеры негативных нотификаций',
    deprecated: true,
    deprecatedMessage: 'Переехал в группу status',
    deprecatedRename: 'negative-pale'
  },
  'negative-pressed': {
    desktopValue: '#F522223D',
    desktopDarkValue: '#731F20',
    iosValue: '#F522223D',
    iosDarkValue: '#731F20',
    androidValue: '#F522223D',
    androidDarkValue: '#731F20',
    comment: 'Нажатое состояние negative в iOS',
    deprecated: true,
    deprecatedMessage: 'Переехал в группу status',
    deprecatedRename: 'negative-pale-pressed'
  },
  info: {
    desktopValue: '#428BF929',
    desktopDarkValue: '#263B5C',
    iosValue: '#428BF929',
    iosDarkValue: '#263B5C',
    androidValue: '#428BF929',
    androidDarkValue: '#263B5C',
    comment: 'Контейнеры нейтральных нотификаций',
    deprecated: true,
    deprecatedMessage: 'Переехал в группу status',
    deprecatedRename: 'info-pale'
  },
  'info-pressed': {
    desktopValue: '#428BF93D',
    desktopDarkValue: '#2B4976',
    iosValue: '#428BF93D',
    iosDarkValue: '#2B4976',
    androidValue: '#428BF93D',
    androidDarkValue: '#2B4976',
    comment: 'Нажатое состояние info в iOS',
    deprecated: true,
    deprecatedMessage: 'Переехал в группу status',
    deprecatedRename: 'info-pale-pressed'
  },
  accent: {
    desktopValue: '#428BF9',
    desktopDarkValue: '#428BF9',
    iosValue: '#428BF9',
    iosDarkValue: '#428BF9',
    androidValue: '#428BF9',
    androidDarkValue: '#428BF9',
    comment: 'Контейнеры интерактивных элементов. Заменяет цвет engaging',
    deprecated: true,
    deprecatedMessage: 'Заменён на цвет accent-2',
    deprecatedRename: 'accent-2'
  },
  'accent-pressed': {
    desktopValue: '#156ED4',
    desktopDarkValue: '#156ED4',
    iosValue: '#156ED4',
    iosDarkValue: '#156ED4',
    androidValue: '#156ED4',
    androidDarkValue: '#156ED4',
    comment: 'Нажатое состояние цвета accent в iOS. Заменяет цвет engaging-pressed',
    deprecated: true,
    deprecatedMessage: 'Заменён на цвет accent-2-pressed',
    deprecatedRename: 'accent-2-pressed'
  },
  'accent-pale': {
    desktopValue: '#428BF914',
    desktopDarkValue: '#428BF929',
    iosValue: '#428BF914',
    iosDarkValue: '#428BF929',
    androidValue: '#428BF914',
    androidDarkValue: '#428BF929',
    comment: 'Фон tui-button [vertical]',
    deprecated: true,
    deprecatedMessage: 'Заменён на компонентный токен',
    deprecatedRename: 'button-vertical'
  },
  'accent-pale-pressed': {
    desktopValue: '#428BF929',
    desktopDarkValue: '#428BF93D',
    iosValue: '#428BF929',
    iosDarkValue: '#428BF93D',
    androidValue: '#428BF929',
    androidDarkValue: '#428BF93D',
    comment: 'Нажатый стейт accent-pale в iOS',
    deprecated: true,
    deprecatedMessage: 'Заменён на компонентный токен',
    deprecatedRename: 'button-vertical-pressed'
  },
  engaging: {
    desktopValue: '#428BF9',
    desktopDarkValue: '#428BF9',
    iosValue: '#428BF9',
    iosDarkValue: '#428BF9',
    androidValue: '#428BF9',
    androidDarkValue: '#428BF9',
    comment: 'Контейнеры интерактивных элементов',
    deprecated: true,
    deprecatedMessage: 'Заменён на цвет accent',
    deprecatedRename: 'accent'
  },
  'engaging-pressed': {
    desktopValue: '#156ED4',
    desktopDarkValue: '#156ED4',
    iosValue: '#156ED4',
    iosDarkValue: '#156ED4',
    androidValue: '#156ED4',
    androidDarkValue: '#156ED4',
    comment: 'Нажатое состояние цвета элементов с фоном engaging',
    deprecated: true,
    deprecatedMessage: 'Заменён на цвет accent-pressed',
    deprecatedRename: 'accent-pressed'
  },
  'brand-tinkoff': {
    desktopValue: '#FFDD2D',
    desktopDarkValue: '#FFDD2D',
    iosValue: '#FFDD2D',
    iosDarkValue: '#FFDD2D',
    androidValue: '#FFDD2D',
    androidDarkValue: '#FFDD2D',
    comment: 'Фоны акцентных кнопок, бейджей и т.д.',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу brand',
    deprecatedRename: 'accent-1'
  },
  'brand-pro': {
    desktopValue: '#AFF218',
    desktopDarkValue: '#AFF218',
    iosValue: '#AFF218',
    iosDarkValue: '#AFF218',
    androidValue: '#AFF218',
    androidDarkValue: '#AFF218',
    comment: 'Фоны акцентных кнопок, бейджей и т.д.',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу brand',
    deprecatedRename: 'tinkoff-pro'
  },
  'brand-premium': {
    desktopValue: '#4972CF',
    desktopDarkValue: '#4972CF',
    iosValue: '#4972CF',
    iosDarkValue: '#4972CF',
    androidValue: '#4972CF',
    androidDarkValue: '#4972CF',
    comment: 'Фоны акцентных кнопок, бейджей и т.д.',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу brand',
    deprecatedRename: 'tinkoff-premium'
  },
  notification: {
    desktopValue: '#F52222',
    desktopDarkValue: '#F52222',
    iosValue: '#F52222',
    iosDarkValue: '#F52222',
    androidValue: '#F52222',
    androidDarkValue: '#F52222',
    comment: 'Контейнеры нотификационных бейджей',
    deprecated: true,
    deprecatedMessage: 'Переехал в компонентные токены',
    deprecatedRename: 'badge-notification'
  },
  'selected-text': {
    desktopValue: '#428BF93D',
    desktopDarkValue: '#428BF93D',
    iosValue: '#428BF93D',
    iosDarkValue: '#428BF93D',
    androidValue: '#428BF93D',
    androidDarkValue: '#428BF93D',
    comment: 'Фон под выделенным пользователем текстом',
    deprecated: true,
    deprecatedMessage: 'Переехал в отдельную группу service',
    deprecatedRename: 'selected-text'
  },
  'accent-1': {
    desktopValue: '#FFDD2D',
    desktopDarkValue: '#FFDD2D',
    iosValue: '#FFDD2D',
    iosDarkValue: '#FFDD2D',
    androidValue: '#FFDD2D',
    androidDarkValue: '#FFDD2D',
    comment: 'Фоны акцентных кнопок, бейджей и т.д.'
  },
  'accent-1-hover': {
    desktopValue: '#FFCD33',
    desktopDarkValue: '#FFCD33',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Фоны акцентных кнопок, бейджей и т.д. при наведении'
  },
  'accent-1-pressed': {
    desktopValue: '#FAB619',
    desktopDarkValue: '#FAB619',
    iosValue: '#FFCD33',
    iosDarkValue: '#FFCD33',
    androidValue: '#FFCD33',
    androidDarkValue: '#FFCD33',
    comment: 'Фоны акцентных кнопок, бейджей и т.д. при нажатии'
  },
  'accent-2': {
    desktopValue: '#428BF9',
    desktopDarkValue: '#428BF9',
    iosValue: '#428BF9',
    iosDarkValue: '#428BF9',
    androidValue: '#428BF9',
    androidDarkValue: '#428BF9',
    comment: 'Фоны акцентных кнопок, бейджей и т.д.'
  },
  'accent-2-hover': {
    desktopValue: '#126DF7',
    desktopDarkValue: '#126DF7',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Фоны акцентных кнопок, бейджей и т.д. при нажатии'
  },
  'accent-2-pressed': {
    desktopValue: '#156ED4',
    desktopDarkValue: '#156ED4',
    iosValue: '#126DF7',
    iosDarkValue: '#126DF7',
    androidValue: '#126DF7',
    androidDarkValue: '#126DF7',
    comment: 'Фоны акцентных кнопок, бейджей и т.д.'
  },
  'accent-opposite': {
    desktopValue: '#000000',
    desktopDarkValue: '#FFFFFF',
    iosValue: '#000000',
    iosDarkValue: '#FFFFFF',
    androidValue: '#000000',
    androidDarkValue: '#FFFFFF',
    comment: 'Фон, противоположный base: в белой теме — черный, в темной теме — белый'
  },
  'accent-opposite-hover': {
    desktopValue: '#2C2C2E',
    desktopDarkValue: '#F6F7F8',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Фон, противоположный base при наведении: в белой теме — черный, в темной теме — белый'
  },
  'accent-opposite-pressed': {
    desktopValue: '#575B61',
    desktopDarkValue: '#EAECEE',
    iosValue: '#2C2C2E',
    iosDarkValue: '#F6F7F8',
    androidValue: '#2C2C2E',
    androidDarkValue: '#F6F7F8',
    comment: 'Фон, противоположный base при нажатии: в белой теме — черный, в темной теме — белый'
  },
  'accent-on-light': {
    desktopValue: '#000000',
    desktopDarkValue: '#000000',
    iosValue: '#000000',
    iosDarkValue: '#000000',
    androidValue: '#000000',
    androidDarkValue: '#000000',
    comment: 'Контрастные контейнеры на светлых фонах, не меняется при смене темы'
  },
  'accent-on-light-hover': {
    desktopValue: '#292929',
    desktopDarkValue: '#292929',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Контрастные контейнеры при наведении на светлых фонах, не меняется при смене темы.'
  },
  'accent-on-light-pressed': {
    desktopValue: '#383838',
    desktopDarkValue: '#383838',
    iosValue: '#292929',
    iosDarkValue: '#292929',
    androidValue: '#292929',
    androidDarkValue: '#292929',
    comment: 'Контрастные контейнеры при нажатии на светлых фонах, не меняется при смене темы.'
  },
  'accent-on-dark': {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#FFFFFF',
    iosValue: '#FFFFFF',
    iosDarkValue: '#FFFFFF',
    androidValue: '#FFFFFF',
    androidDarkValue: '#FFFFFF',
    comment: 'Контрастные контейнеры на темных фонах, не меняется при смене темы'
  },
  'accent-on-dark-hover': {
    desktopValue: '#F6F7F8',
    desktopDarkValue: '#F6F7F8',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Контрастные контейнеры при наведении на темных фонах, не меняется при смене темы.'
  },
  'accent-on-dark-pressed': {
    desktopValue: '#EAECEE',
    desktopDarkValue: '#EAECEE',
    iosValue: '#F6F7F8',
    iosDarkValue: '#F6F7F8',
    androidValue: '#F6F7F8',
    androidDarkValue: '#F6F7F8',
    comment: 'Контрастные контейнеры при нажатии на темных фонах, не меняется при смене темы.'
  },
  'button-close-on-light': {
    desktopValue: '#00000066',
    desktopDarkValue: '#00000066',
    iosValue: '#00000066',
    iosDarkValue: '#00000066',
    androidValue: '#00000066',
    androidDarkValue: '#00000066',
    comment: 'Фон кнопки закрытия на светлом фоне. не меняется при переключении темы. бывший цвет neutral-3-on-light. Временный компонентный токен, существует пока не зарелизятся токены 2.0.'
  },
  'button-close-on-dark': {
    desktopValue: '#FFFFFF80',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#FFFFFF80',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#FFFFFF80',
    androidDarkValue: '#FFFFFF80',
    comment: 'Фон кнопки закрытия на темном фоне. не меняется при переключении темы. бывший цвет neutral-3-on-dark. Временный компонентный токен, существует пока не зарелизятся токены 2.0.',
    deprecated: true,
    deprecatedMessage: 'Заменен на overlay-glass-on-dark',
    deprecatedRename: 'overlay-glass-on-dark'
  },
  'badge-notification': {
    desktopValue: '#F52222',
    desktopDarkValue: '#F52222',
    iosValue: '#F52222',
    iosDarkValue: '#F52222',
    androidValue: '#F52222',
    androidDarkValue: '#F52222',
    comment: 'Контейнеры нотификационных бейджей. Временный компонентный токен, существует пока не зарелизятся токены 2.0.'
  },
  toggle: {
    desktopValue: '#0010241F',
    desktopDarkValue: '#FFFFFF33',
    iosValue: '#0010241F',
    iosDarkValue: '#FFFFFF33',
    androidValue: '#0010241F',
    androidDarkValue: '#FFFFFF33',
    comment: 'Фон неактивного чекбокса, тоггла, радиобаттона. Временный компонентный токен, существует пока не зарелизятся токены 2.0.',
    deprecated: true,
    deprecatedMessage: 'Заменен на background.neutral-2',
    deprecatedRename: 'neutral-2'
  },
  'button-vertical': {
    desktopValue: '#428BF914',
    desktopDarkValue: '#428BF929',
    iosValue: '#428BF914',
    iosDarkValue: '#428BF929',
    androidValue: '#428BF914',
    androidDarkValue: '#428BF929',
    comment: 'Фон tui-button [vertical]. Временный компонентный токен, существует пока не зарелизятся токены 2.0.'
  },
  'button-vertical-hover': {
    desktopValue: '#428BF91F',
    desktopDarkValue: '#428BF933',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Фон tui-button [vertical]. Временный компонентный токен, существует пока не зарелизятся токены 2.0.'
  },
  'button-vertical-pressed': {
    desktopValue: '#428BF929',
    desktopDarkValue: '#428BF93D',
    iosValue: '#428BF929',
    iosDarkValue: '#428BF93D',
    androidValue: '#428BF929',
    androidDarkValue: '#428BF93D',
    comment: 'Фон tui-button [vertical] при нажатии и наведении. Временный компонентный токен, существует пока не зарелизятся токены 2.0.'
  },
  'button-glass-on-dark': {
    desktopValue: '#FFFFFF4D',
    desktopDarkValue: '#FFFFFF4D',
    iosValue: '#FFFFFF4D',
    iosDarkValue: '#FFFFFF4D',
    androidValue: '#FFFFFF4D',
    androidDarkValue: '#FFFFFF4D',
    comment: 'Фон стеклянной кнопки на темных фонах, не меняется при смене темы. Временный компонентный токен, существует пока не зарелизятся токены 2.0.',
    deprecated: true,
    deprecatedMessage: 'Заменен на overlay-glass-on-dark',
    deprecatedRename: 'overlay-glass-on-dark'
  },
  'button-glass-on-light': {
    desktopValue: '#00000066',
    desktopDarkValue: '#00000066',
    iosValue: '#00000066',
    iosDarkValue: '#00000066',
    androidValue: '#00000066',
    androidDarkValue: '#00000066',
    comment: 'Фон стеклянной кнопки на светлых фонах, не меняется при смене темы. Временный компонентный токен, существует пока не зарелизятся токены 2.0',
    deprecated: true,
    deprecatedMessage: 'Заменен на overlay-glass-on-light',
    deprecatedRename: 'overlay-glass-on-light'
  },
  'progress-bar': {
    desktopValue: '#0010240F',
    desktopDarkValue: '#FFFFFF26',
    iosValue: '#0010240F',
    iosDarkValue: '#FFFFFF26',
    androidValue: '#0010240F',
    androidDarkValue: '#FFFFFF26',
    comment: 'Пустая полоска прогресс-баров. Временный компонентный токен, существует пока не зарелизятся токены 2.0.'
  },
  tooltip: {
    desktopValue: '#575B61',
    desktopDarkValue: '#FFFFFF',
    iosValue: '#575B61',
    iosDarkValue: '#79818C',
    androidValue: '#575B61',
    androidDarkValue: '#79818C',
    comment: 'Фон для тултипов'
  },
  'thumbnail-card-badge': {
    desktopValue: '#0000001F',
    desktopDarkValue: '#0000001F',
    iosValue: '#0000001F',
    iosDarkValue: '#0000001F',
    androidValue: '#0000001F',
    androidDarkValue: '#0000001F',
    comment: 'Прозрачный контейнер бейджа на миниатюре карты. Временный компонентный токен, существует пока не зарелизятся токены 2.0.'
  },
  'overlay-glass': {
    desktopValue: '#00000066',
    desktopDarkValue: '#FFFFFF4D',
    iosValue: '#00000066',
    iosDarkValue: '#FFFFFF4D',
    androidValue: '#00000066',
    androidDarkValue: '#FFFFFF4D',
    comment: 'Оверлей стеклянных поверхностей'
  },
  'overlay-glass-hover': {
    desktopValue: '#0000007A',
    desktopDarkValue: '#FFFFFF66',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Оверлей стеклянных поверхностей при наведении'
  },
  'overlay-glass-pressed': {
    desktopValue: '#00000099',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#00000099',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#00000099',
    androidDarkValue: '#FFFFFF80',
    comment: 'Оверлей стеклянных поверхностей при нажатии'
  },
  'overlay-glass-on-dark': {
    desktopValue: '#FFFFFF4D',
    desktopDarkValue: '#FFFFFF4D',
    iosValue: '#FFFFFF4D',
    iosDarkValue: '#FFFFFF4D',
    androidValue: '#FFFFFF4D',
    androidDarkValue: '#FFFFFF4D',
    comment: 'Оверлей стеклянных поверхностей на темных фонах, не меняется при смене темы.'
  },
  'overlay-glass-on-dark-hover': {
    desktopValue: '#FFFFFF66',
    desktopDarkValue: '#FFFFFF66',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Оверлей стеклянных поверхностей при наведении на темных фонах, не меняется при смене темы.'
  },
  'overlay-glass-on-dark-pressed': {
    desktopValue: '#FFFFFF80',
    desktopDarkValue: '#FFFFFF80',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Оверлей стеклянных поверхностей при нажатии на темных фонах, не меняется при смене темы.'
  },
  'overlay-glass-on-light': {
    desktopValue: '#00000066',
    desktopDarkValue: '#00000066',
    iosValue: '#00000066',
    iosDarkValue: '#00000066',
    androidValue: '#00000066',
    androidDarkValue: '#00000066',
    comment: 'Оверлей стеклянных поверхностей на светлых фонах, не меняется при смене темы'
  },
  'overlay-glass-on-light-pressed': {
    desktopValue: '#00000099',
    desktopDarkValue: '#00000099',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Оверлей стеклянных поверхностей при нажатии на светлых фонах, не меняется при смене темы.'
  },
  'overlay-glass-on-light-hover': {
    desktopValue: '#0000007A',
    desktopDarkValue: '#0000007A',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Оверлей стеклянных поверхностей при наведении на светлых фонах, не меняется при смене темы.'
  },
  'overlay-glass-matte': {
    desktopValue: '#FFFFFFCC',
    desktopDarkValue: '#202020CC',
    iosValue: '#FFFFFFCC',
    iosDarkValue: '#000000CC',
    androidValue: '#FFFFFFCC',
    androidDarkValue: '#000000CC',
    comment: 'Оверлей матовых стеклянных поверхностей, не меняется при смене темы.'
  },
  'overlay-on-image': {
    desktopValue: '#0000004D',
    desktopDarkValue: '#0000004D',
    iosValue: '#0000004D',
    iosDarkValue: '#0000004D',
    androidValue: '#0000004D',
    androidDarkValue: '#0000004D',
    comment: 'Оверлей поверх изображений, не меняется от темы.'
  }
};
const border = {
  normal: {
    desktopValue: '#0010241F',
    desktopDarkValue: '#FFFFFF26',
    iosValue: '#0010241F',
    iosDarkValue: '#FFFFFF30',
    androidValue: '#0010241F',
    androidDarkValue: '#FFFFFF30',
    comment: 'Бордеры и сепараторы на основных фонах'
  },
  'normal-pale': {
    desktopValue: '#00102412',
    desktopDarkValue: '#FFFFFF17',
    iosValue: '#00102412',
    iosDarkValue: '#ffffff21',
    androidValue: '#00102412',
    androidDarkValue: '#ffffff21',
    comment: 'Бледные бордеры и сепараторы на основных фонах'
  },
  hover: {
    desktopValue: '#00102438',
    desktopDarkValue: '#FFFFFF33',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Бордеры при наведении'
  },
  'normal-opaque': {
    desktopValue: '#E1E3E4',
    desktopDarkValue: '#414141',
    iosValue: '#E1E3E4',
    iosDarkValue: '#303030',
    androidValue: '#E1E3E4',
    androidDarkValue: '#303030',
    comment: 'Бордеры и сепараторы на основных фонах без прозрачности'
  },
  'normal-opaque-hover': {
    desktopValue: '#C7CBCF',
    desktopDarkValue: '#4D4D4D',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Бордеры и сепараторы на основных фонах без прозрачности'
  },
  'normal-pale-opaque': {
    desktopValue: '#EDEFF2',
    desktopDarkValue: '#333333',
    iosValue: '#EDEFF2',
    iosDarkValue: '#202020',
    androidValue: '#EDEFF2',
    androidDarkValue: '#202020',
    comment: 'Бледные непрозрачные бордеры и сепараторы на основных фонах'
  },
  'normal-strong': {
    desktopValue: '#00102452',
    desktopDarkValue: '#FFFFFF66',
    iosValue: '#00102452',
    iosDarkValue: '#FFFFFF66',
    androidValue: '#00102452',
    androidDarkValue: '#FFFFFF66',
    comment: 'Бордеры и сепараторы на основных фонах'
  },
  focus: {
    desktopValue: '#00102470',
    desktopDarkValue: '#FFFFFF',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Бордеры при фокусировании с клавиатуры'
  },
  'focus-on-dark': {
    desktopValue: '#FFFFFF4D',
    desktopDarkValue: '#FFFFFF4D',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Бордеры при фокусировании с клавиатуры темных элементов'
  },
  selected: {
    desktopValue: '#FFDD2D',
    desktopDarkValue: '#FFDD2D',
    iosValue: '#428BF9',
    iosDarkValue: '#428BF9',
    androidValue: '#428BF9',
    androidDarkValue: '#428BF9',
    comment: 'Обводка выделенных элементов'
  },
  'selected-grayscale': {
    desktopValue: '#575B61',
    desktopDarkValue: '#EAECEE',
    iosValue: '#575B61',
    iosDarkValue: '#EAECEE',
    androidValue: '#575B61',
    androidDarkValue: '#EAECEE',
    comment: 'Обводка выделенных элементов'
  },
  'darkmode-only': {
    desktopValue: '#00000000',
    desktopDarkValue: '#FFFFFF1A',
    iosValue: '#00000000',
    iosDarkValue: '#FFFFFF1A',
    androidValue: '#00000000',
    androidDarkValue: '#FFFFFF1A',
    comment: 'Обводка, отделяющая цветные элементы от фона в темной теме'
  },
  'on-light': {
    desktopValue: '#0010241F',
    desktopDarkValue: '#0010241F',
    iosValue: '#00000008',
    iosDarkValue: '#00000008',
    androidValue: '#00000008',
    androidDarkValue: '#00000008',
    comment: 'Обводка, отделяющая цветные элементы от светлого фонов'
  },
  'on-light-hover': {
    desktopValue: '#00102438',
    desktopDarkValue: '#00102438',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Обводка, отделяющая цветные элементы на светлых фонах'
  },
  'on-dark': {
    desktopValue: '#FFFFFF26',
    desktopDarkValue: '#FFFFFF26',
    iosValue: '#FFFFFF1A',
    iosDarkValue: '#FFFFFF1A',
    androidValue: '#FFFFFF1A',
    androidDarkValue: '#FFFFFF1A',
    comment: 'Обводка, отделяющая цветные элементы на темных фонах'
  },
  'on-dark-hover': {
    desktopValue: '#FFFFFF33',
    desktopDarkValue: '#FFFFFF33',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Обводка, отделяющая цветные элементы на темных фонах при наведении'
  }
};
const brand = {
  't-bank': {
    desktopValue: '#FFDD2D',
    desktopDarkValue: '#FFDD2D',
    iosValue: '#FFDD2D',
    iosDarkValue: '#FFDD2D',
    androidValue: '#FFDD2D',
    androidDarkValue: '#FFDD2D',
    comment: 'Фирменный цвет. Используется, например, в бейдже подписки Team'
  },
  pro: {
    desktopValue: '#AFF218',
    desktopDarkValue: '#AFF218',
    iosValue: '#AFF218',
    iosDarkValue: '#AFF218',
    androidValue: '#AFF218',
    androidDarkValue: '#AFF218',
    comment: 'Цвет подписки Pro, для фонов кнопок, бейджей и т.д.'
  },
  'pro-alt-1': {
    desktopValue: '#9AF526',
    desktopDarkValue: '#9AF526',
    iosValue: '#9AF526',
    iosDarkValue: '#9AF526',
    androidValue: '#9AF526',
    androidDarkValue: '#9AF526',
    comment: 'Дополнительный цвет подписки Pro.'
  },
  premium: {
    desktopValue: '#4972CF',
    desktopDarkValue: '#4972CF',
    iosValue: '#4972CF',
    iosDarkValue: '#4972CF',
    androidValue: '#4972CF',
    androidDarkValue: '#4972CF',
    comment: 'Цвет подписки Premium, для фонов кнопок, бейджей и т.д.'
  },
  black: {
    desktopValue: '#333333',
    desktopDarkValue: '#333333',
    iosValue: '#333333',
    iosDarkValue: '#333333',
    androidValue: '#333333',
    androidDarkValue: '#333333',
    comment: 'Фирменный цвет T-Bank Black'
  },
  platinum: {
    desktopValue: '#747B8F',
    desktopDarkValue: '#747B8F',
    iosValue: '#747B8F',
    iosDarkValue: '#747B8F',
    androidValue: '#747B8F',
    androidDarkValue: '#747B8F',
    comment: 'Фирменный цвет T-Bank Platinum'
  },
  't-mobile': {
    desktopValue: '#5848C3',
    desktopDarkValue: '#5848C3',
    iosValue: '#5848C3',
    iosDarkValue: '#5848C3',
    androidValue: '#5848C3',
    androidDarkValue: '#5848C3',
    comment: 'Фирменный цвет Tinkoff Mobile'
  },
  't-mobile-alt-1': {
    desktopValue: '#BAB3EC',
    desktopDarkValue: '#BAB3EC',
    iosValue: '#BAB3EC',
    iosDarkValue: '#BAB3EC',
    androidValue: '#BAB3EC',
    androidDarkValue: '#BAB3EC',
    comment: 'Альтеранитивный фирменный цвет T-Mobile'
  },
  't-mobile-alt-2': {
    desktopValue: '#EDE8F6',
    desktopDarkValue: '#EDE8F6',
    iosValue: '#EDE8F6',
    iosDarkValue: '#EDE8F6',
    androidValue: '#EDE8F6',
    androidDarkValue: '#EDE8F6',
    comment: 'Альтеранитивный фирменный цвет T-Mobile'
  },
  'all-airlines': {
    desktopValue: '#27BEFF',
    desktopDarkValue: '#27BEFF',
    iosValue: '#27BEFF',
    iosDarkValue: '#27BEFF',
    androidValue: '#27BEFF',
    androidDarkValue: '#27BEFF',
    comment: 'Фирменный цвет All Airlines'
  },
  'all-airlines-alt-1': {
    desktopValue: '#CBEFFF',
    desktopDarkValue: '#CBEFFF',
    iosValue: '#CBEFFF',
    iosDarkValue: '#CBEFFF',
    androidValue: '#CBEFFF',
    androidDarkValue: '#CBEFFF',
    comment: 'Бледный оттенок фирменного цвета All Airlines'
  },
  't-ai-assistant': {
    desktopValue: '#9A6BFF',
    desktopDarkValue: '#9A6BFF',
    iosValue: '#9A6BFF',
    iosDarkValue: '#9A6BFF',
    androidValue: '#9A6BFF',
    androidDarkValue: '#9A6BFF',
    comment: 'Фирменный цвет Tinkoff Ai Assistant'
  },
  't-insurance': {
    desktopValue: '#27AFA5',
    desktopDarkValue: '#27AFA5',
    iosValue: '#27AFA5',
    iosDarkValue: '#27AFA5',
    androidValue: '#27AFA5',
    androidDarkValue: '#27AFA5',
    comment: 'Фирменный цвет Страхования'
  },
  't-business': {
    desktopValue: '#B58B60',
    desktopDarkValue: '#B58B60',
    iosValue: '#B58B60',
    iosDarkValue: '#B58B60',
    androidValue: '#B58B60',
    androidDarkValue: '#B58B60',
    comment: 'Фирменный цвет Бизнеса'
  },
  't-business-alt-1': {
    desktopValue: '#E4D7C1',
    desktopDarkValue: '#E4D7C1',
    iosValue: '#E4D7C1',
    iosDarkValue: '#E4D7C1',
    androidValue: '#E4D7C1',
    androidDarkValue: '#E4D7C1',
    comment: 'Фирменный цвет Бизнеса'
  },
  't-invest': {
    desktopValue: '#41414D',
    desktopDarkValue: '#41414D',
    iosValue: '#41414D',
    iosDarkValue: '#41414D',
    androidValue: '#41414D',
    androidDarkValue: '#41414D',
    comment: 'Фирменный цвет Инвестиций'
  },
  private: {
    desktopValue: '#212121',
    desktopDarkValue: '#212121',
    iosValue: '#212121',
    iosDarkValue: '#212121',
    androidValue: '#212121',
    androidDarkValue: '#212121',
    comment: 'Фирменный цвет подписки Private'
  },
  'mir-pay': {
    desktopValue: '#006848',
    desktopDarkValue: '#006848',
    iosValue: '#006848',
    iosDarkValue: '#006848',
    androidValue: '#006848',
    androidDarkValue: '#006848',
    comment: 'Цвет для кнопок Mir Pay'
  },
  't-insurance-alt-1': {
    desktopValue: '#D0F4F2',
    desktopDarkValue: '#D0F4F2',
    iosValue: '#D0F4F2',
    iosDarkValue: '#D0F4F2',
    androidValue: '#D0F4F2',
    androidDarkValue: '#D0F4F2',
    comment: 'Бледный оттенок фирменного цвета Страхования'
  },
  tinkoff: {
    desktopValue: '#FFDD2D',
    desktopDarkValue: '#FFDD2D',
    iosValue: '#FFDD2D',
    iosDarkValue: '#FFDD2D',
    androidValue: '#FFDD2D',
    androidDarkValue: '#FFDD2D',
    comment: 'Фирменный цвет. Используется, например, в бейдже подписки Team',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-bank',
    deprecatedRename: 't-bank'
  },
  'tinkoff-pro': {
    desktopValue: '#AFF218',
    desktopDarkValue: '#AFF218',
    iosValue: '#AFF218',
    iosDarkValue: '#AFF218',
    androidValue: '#AFF218',
    androidDarkValue: '#AFF218',
    comment: 'Цвет подписки Tinkoff PRO. для фонов кнопок, бейджей и т.д.',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-pro',
    deprecatedRename: 't-pro'
  },
  'tinkoff-premium': {
    desktopValue: '#4972CF',
    desktopDarkValue: '#4972CF',
    iosValue: '#4972CF',
    iosDarkValue: '#4972CF',
    androidValue: '#4972CF',
    androidDarkValue: '#4972CF',
    comment: 'Цвет подписки Tinkoff Premium. для фонов кнопок, бейджей и т.д.',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-premium',
    deprecatedRename: 't-premium'
  },
  'tinkoff-black': {
    desktopValue: '#333333',
    desktopDarkValue: '#333333',
    iosValue: '#333333',
    iosDarkValue: '#333333',
    androidValue: '#333333',
    androidDarkValue: '#333333',
    comment: 'Фирменный цвет Tinkoff Black',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-black',
    deprecatedRename: 't-black'
  },
  'tinkoff-platinum': {
    desktopValue: '#747B8F',
    desktopDarkValue: '#747B8F',
    iosValue: '#747B8F',
    iosDarkValue: '#747B8F',
    androidValue: '#747B8F',
    androidDarkValue: '#747B8F',
    comment: 'Фирменный цвет Tinkoff Platinum',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-platinum',
    deprecatedRename: 't-platinum'
  },
  'tinkoff-mobile': {
    desktopValue: '#5848C3',
    desktopDarkValue: '#5848C3',
    iosValue: '#5848C3',
    iosDarkValue: '#5848C3',
    androidValue: '#5848C3',
    androidDarkValue: '#5848C3',
    comment: 'Фирменный цвет Tinkoff Mobile',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-mobile',
    deprecatedRename: 't-mobile'
  },
  'tinkoff-mobile-alt-1': {
    desktopValue: '#BAB3EC',
    desktopDarkValue: '#BAB3EC',
    iosValue: '#BAB3EC',
    iosDarkValue: '#BAB3EC',
    androidValue: '#BAB3EC',
    androidDarkValue: '#BAB3EC',
    comment: 'Фирменный цвет Tinkoff Mobile',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-mobile-alt-1',
    deprecatedRename: 't-mobile-alt-1'
  },
  'tinkoff-all-airlines': {
    desktopValue: '#27BEFF',
    desktopDarkValue: '#27BEFF',
    iosValue: '#27BEFF',
    iosDarkValue: '#27BEFF',
    androidValue: '#27BEFF',
    androidDarkValue: '#27BEFF',
    comment: 'Фирменный цвет Tinkoff Mobile',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-all-airlines',
    deprecatedRename: 't-all-airlines'
  },
  'tinkoff-all-airlines-alt-1': {
    desktopValue: '#CBEFFF',
    desktopDarkValue: '#CBEFFF',
    iosValue: '#CBEFFF',
    iosDarkValue: '#CBEFFF',
    androidValue: '#CBEFFF',
    androidDarkValue: '#CBEFFF',
    comment: 'Бледный оттенок фирменного цвета Tinkoff All Airlines',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-all-airlines-alt-1',
    deprecatedRename: 't-all-airlines-alt-1'
  },
  'tinkoff-ai-assistant': {
    desktopValue: '#9A6BFF',
    desktopDarkValue: '#9A6BFF',
    iosValue: '#9A6BFF',
    iosDarkValue: '#9A6BFF',
    androidValue: '#9A6BFF',
    androidDarkValue: '#9A6BFF',
    comment: 'Фирменный цвет Tinkoff Ai Assistant',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-ai-assistant',
    deprecatedRename: 't-ai-assistant'
  },
  'tinkoff-insurance': {
    desktopValue: '#27AFA5',
    desktopDarkValue: '#27AFA5',
    iosValue: '#27AFA5',
    iosDarkValue: '#27AFA5',
    androidValue: '#27AFA5',
    androidDarkValue: '#27AFA5',
    comment: 'Фирменный цвет Страхования',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-insurance',
    deprecatedRename: 't-insurance'
  },
  'tinkoff-business': {
    desktopValue: '#B58B60',
    desktopDarkValue: '#B58B60',
    iosValue: '#B58B60',
    iosDarkValue: '#B58B60',
    androidValue: '#B58B60',
    androidDarkValue: '#B58B60',
    comment: 'Фирменный цвет Бизнеса',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-business',
    deprecatedRename: 't-business'
  },
  'tinkoff-business-alt-1': {
    desktopValue: '#E4D7C1',
    desktopDarkValue: '#E4D7C1',
    iosValue: '#E4D7C1',
    iosDarkValue: '#E4D7C1',
    androidValue: '#E4D7C1',
    androidDarkValue: '#E4D7C1',
    comment: 'Фирменный цвет Бизнеса',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-business-alt-1',
    deprecatedRename: 't-business-alt-1'
  },
  'tinkoff-invest': {
    desktopValue: '#41414D',
    desktopDarkValue: '#41414D',
    iosValue: '#41414D',
    iosDarkValue: '#41414D',
    androidValue: '#41414D',
    androidDarkValue: '#41414D',
    comment: 'Фирменный цвет Инвестиций',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-invest',
    deprecatedRename: 't-invest'
  },
  'tinkoff-private': {
    desktopValue: '#212121',
    desktopDarkValue: '#212121',
    iosValue: '#212121',
    iosDarkValue: '#212121',
    androidValue: '#212121',
    androidDarkValue: '#212121',
    comment: 'Фирменный цвет Private',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-private',
    deprecatedRename: 't-private'
  },
  'tinkoff-insurance-pale': {
    desktopValue: '#D0F4F2',
    desktopDarkValue: '#D0F4F2',
    iosValue: '#D0F4F2',
    iosDarkValue: '#D0F4F2',
    androidValue: '#D0F4F2',
    androidDarkValue: '#D0F4F2',
    comment: 'Бледный оттенок фирменного цвета Страхования',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-insurance-alt-1',
    deprecatedRename: 't-insurance-alt-1'
  },
  'tinkoff-insurance-alt-1': {
    desktopValue: '#E1F9F7',
    desktopDarkValue: '#E1F9F7',
    iosValue: '#E1F9F7',
    iosDarkValue: '#E1F9F7',
    androidValue: '#E1F9F7',
    androidDarkValue: '#E1F9F7',
    comment: 'Бледный оттенок фирменного цвета Страхования',
    deprecated: true,
    deprecatedMessage: 'Заменён на t-insurance-alt-1',
    deprecatedRename: 't-insurance-alt-1'
  },
  't-all-airlines': {
    desktopValue: '#27BEFF',
    desktopDarkValue: '#27BEFF',
    iosValue: '#27BEFF',
    iosDarkValue: '#27BEFF',
    androidValue: '#27BEFF',
    androidDarkValue: '#27BEFF',
    comment: 'Фирменный цвет All Airlines',
    deprecated: true,
    deprecatedMessage: 'Заменён на all-airlines',
    deprecatedRename: 'all-airlines'
  },
  't-all-airlines-alt-1': {
    desktopValue: '#CBEFFF',
    desktopDarkValue: '#CBEFFF',
    iosValue: '#CBEFFF',
    iosDarkValue: '#CBEFFF',
    androidValue: '#CBEFFF',
    androidDarkValue: '#CBEFFF',
    comment: 'Бледный оттенок фирменного цвета All Airlines',
    deprecated: true,
    deprecatedMessage: 'Заменён на all-airlines-alt-1',
    deprecatedRename: 'all-airlines-alt-1'
  },
  't-black': {
    desktopValue: '#333333',
    desktopDarkValue: '#333333',
    iosValue: '#333333',
    iosDarkValue: '#333333',
    androidValue: '#333333',
    androidDarkValue: '#333333',
    comment: 'Фирменный цвет T-Bank Black',
    deprecated: true,
    deprecatedMessage: 'Заменён на black',
    deprecatedRename: 'black'
  },
  't-platinum': {
    desktopValue: '#747B8F',
    desktopDarkValue: '#747B8F',
    iosValue: '#747B8F',
    iosDarkValue: '#747B8F',
    androidValue: '#747B8F',
    androidDarkValue: '#747B8F',
    comment: 'Фирменный цвет Tinkoff Platinum',
    deprecated: true,
    deprecatedMessage: 'Заменён на platinum',
    deprecatedRename: 'platinum'
  },
  't-premium': {
    desktopValue: '#4972CF',
    desktopDarkValue: '#4972CF',
    iosValue: '#4972CF',
    iosDarkValue: '#4972CF',
    androidValue: '#4972CF',
    androidDarkValue: '#4972CF',
    comment: 'Цвет подписки Tinkoff Premium, для фонов кнопок, бейджей и т.д.',
    deprecated: true,
    deprecatedMessage: 'Заменён на premium',
    deprecatedRename: 'premium'
  },
  't-pro': {
    desktopValue: '#AFF218',
    desktopDarkValue: '#AFF218',
    iosValue: '#AFF218',
    iosDarkValue: '#AFF218',
    androidValue: '#AFF218',
    androidDarkValue: '#AFF218',
    comment: 'Цвет подписки Tinkoff PRO, для фонов кнопок, бейджей и т.д.',
    deprecated: true,
    deprecatedMessage: 'Заменён на pro',
    deprecatedRename: 'pro'
  },
  't-private': {
    desktopValue: '#212121',
    desktopDarkValue: '#212121',
    iosValue: '#212121',
    iosDarkValue: '#212121',
    androidValue: '#212121',
    androidDarkValue: '#212121',
    comment: 'Фирменный цвет Private',
    deprecated: true,
    deprecatedMessage: 'Заменён на private',
    deprecatedRename: 'private'
  }
};
const chart = {
  'categorical-01': {
    desktopValue: '#2ABBF4',
    desktopDarkValue: '#2ABBF4',
    iosValue: '#2ABBF4',
    iosDarkValue: '#2ABBF4',
    androidValue: '#2ABBF4',
    androidDarkValue: '#2ABBF4'
  },
  'categorical-02': {
    desktopValue: '#C277F8',
    desktopDarkValue: '#C277F8',
    iosValue: '#C277F8',
    iosDarkValue: '#C277F8',
    androidValue: '#C277F8',
    androidDarkValue: '#C277F8'
  },
  'categorical-03': {
    desktopValue: '#F5593D',
    desktopDarkValue: '#F5593D',
    iosValue: '#F5593D',
    iosDarkValue: '#F5593D',
    androidValue: '#F5593D',
    androidDarkValue: '#F5593D'
  },
  'categorical-04': {
    desktopValue: '#0BD5C1',
    desktopDarkValue: '#0BD5C1',
    iosValue: '#0BD5C1',
    iosDarkValue: '#0BD5C1',
    androidValue: '#0BD5C1',
    androidDarkValue: '#0BD5C1'
  },
  'categorical-05': {
    desktopValue: '#FFB74C',
    desktopDarkValue: '#FFB74C',
    iosValue: '#FFB74C',
    iosDarkValue: '#FFB74C',
    androidValue: '#FFB74C',
    androidDarkValue: '#FFB74C'
  },
  'categorical-06': {
    desktopValue: '#D08FFF',
    desktopDarkValue: '#D08FFF',
    iosValue: '#D08FFF',
    iosDarkValue: '#D08FFF',
    androidValue: '#D08FFF',
    androidDarkValue: '#D08FFF'
  },
  'categorical-07': {
    desktopValue: '#00A328',
    desktopDarkValue: '#00A328',
    iosValue: '#00A328',
    iosDarkValue: '#00A328',
    androidValue: '#00A328',
    androidDarkValue: '#00A328'
  },
  'categorical-08': {
    desktopValue: '#6BA4FA',
    desktopDarkValue: '#6BA4FA',
    iosValue: '#6BA4FA',
    iosDarkValue: '#6BA4FA',
    androidValue: '#6BA4FA',
    androidDarkValue: '#6BA4FA'
  },
  'categorical-09': {
    desktopValue: '#F59200',
    desktopDarkValue: '#F59200',
    iosValue: '#F59200',
    iosDarkValue: '#F59200',
    androidValue: '#F59200',
    androidDarkValue: '#F59200'
  },
  'categorical-10': {
    desktopValue: '#A25BC3',
    desktopDarkValue: '#A25BC3',
    iosValue: '#A25BC3',
    iosDarkValue: '#A25BC3',
    androidValue: '#A25BC3',
    androidDarkValue: '#A25BC3'
  },
  'categorical-11': {
    desktopValue: '#FF7A91',
    desktopDarkValue: '#FF7A91',
    iosValue: '#FF7A91',
    iosDarkValue: '#FF7A91',
    androidValue: '#FF7A91',
    androidDarkValue: '#FF7A91'
  },
  'categorical-12': {
    desktopValue: '#0B9CD5',
    desktopDarkValue: '#0B9CD5',
    iosValue: '#0B9CD5',
    iosDarkValue: '#0B9CD5',
    androidValue: '#0B9CD5',
    androidDarkValue: '#0B9CD5'
  },
  'categorical-13': {
    desktopValue: '#FFA51F',
    desktopDarkValue: '#FFA51F',
    iosValue: '#FFA51F',
    iosDarkValue: '#FFA51F',
    androidValue: '#FFA51F',
    androidDarkValue: '#FFA51F'
  },
  'categorical-14': {
    desktopValue: '#AB6AC8',
    desktopDarkValue: '#AB6AC8',
    iosValue: '#AB6AC8',
    iosDarkValue: '#AB6AC8',
    androidValue: '#AB6AC8',
    androidDarkValue: '#AB6AC8'
  },
  'categorical-15': {
    desktopValue: '#F6516C',
    desktopDarkValue: '#F6516C',
    iosValue: '#F6516C',
    iosDarkValue: '#F6516C',
    androidValue: '#F6516C',
    androidDarkValue: '#F6516C'
  },
  'categorical-16': {
    desktopValue: '#2EA866',
    desktopDarkValue: '#2EA866',
    iosValue: '#2EA866',
    iosDarkValue: '#2EA866',
    androidValue: '#2EA866',
    androidDarkValue: '#2EA866'
  },
  'categorical-17': {
    desktopValue: '#FF6347',
    desktopDarkValue: '#FF6347',
    iosValue: '#FF6347',
    iosDarkValue: '#FF6347',
    androidValue: '#FF6347',
    androidDarkValue: '#FF6347'
  },
  'categorical-18': {
    desktopValue: '#8B4EA6',
    desktopDarkValue: '#8B4EA6',
    iosValue: '#8B4EA6',
    iosDarkValue: '#8B4EA6',
    androidValue: '#8B4EA6',
    androidDarkValue: '#8B4EA6'
  },
  'categorical-19': {
    desktopValue: '#E74023',
    desktopDarkValue: '#E74023',
    iosValue: '#E74023',
    iosDarkValue: '#E74023',
    androidValue: '#E74023',
    androidDarkValue: '#E74023'
  },
  'categorical-20': {
    desktopValue: '#36C578',
    desktopDarkValue: '#36C578',
    iosValue: '#36C578',
    iosDarkValue: '#36C578',
    androidValue: '#36C578',
    androidDarkValue: '#36C578'
  },
  'categorical-21': {
    desktopValue: '#09AE9E',
    desktopDarkValue: '#09AE9E',
    iosValue: '#09AE9E',
    iosDarkValue: '#09AE9E',
    androidValue: '#09AE9E',
    androidDarkValue: '#09AE9E'
  },
  'categorical-22': {
    desktopValue: '#F53D5C',
    desktopDarkValue: '#F53D5C',
    iosValue: '#F53D5C',
    iosDarkValue: '#F53D5C',
    androidValue: '#F53D5C',
    androidDarkValue: '#F53D5C'
  },
  'categorical-23': {
    desktopValue: '#FFCD33',
    desktopDarkValue: '#FFCD33',
    iosValue: '#FFCD33',
    iosDarkValue: '#FFCD33',
    androidValue: '#FFCD33',
    androidDarkValue: '#FFCD33'
  },
  'categorical-24': {
    desktopValue: '#0AC2AF',
    desktopDarkValue: '#0AC2AF',
    iosValue: '#0AC2AF',
    iosDarkValue: '#0AC2AF',
    androidValue: '#0AC2AF',
    androidDarkValue: '#0AC2AF'
  },
  'categorical-25': {
    desktopValue: '#94D274',
    desktopDarkValue: '#94D274',
    iosValue: '#94D274',
    iosDarkValue: '#94D274',
    androidValue: '#94D274',
    androidDarkValue: '#94D274'
  },
  'categorical-26': {
    desktopValue: '#5ACAF6',
    desktopDarkValue: '#5ACAF6',
    iosValue: '#5ACAF6',
    iosDarkValue: '#5ACAF6',
    androidValue: '#5ACAF6',
    androidDarkValue: '#5ACAF6'
  },
  'categorical-27': {
    desktopValue: '#60C366',
    desktopDarkValue: '#60C366',
    iosValue: '#60C366',
    iosDarkValue: '#60C366',
    androidValue: '#60C366',
    androidDarkValue: '#60C366'
  }
};
const component = {
  'tab-bar-background-ios': {
    desktopValue: '#F6F7F8CC',
    desktopDarkValue: '#1A1A1DB3',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Цвет фона для имитации системного таббара iOS'
  },
  'input-background-autofill': {
    desktopValue: '#FFF5C2',
    desktopDarkValue: '#614F23',
    iosValue: '#FFF5C2',
    iosDarkValue: '#614F23',
    androidValue: '#FFF5C2',
    androidDarkValue: '#614F23',
    comment: 'Цвет фона при автозаполнении инпута',
    deprecated: true,
    deprecatedMessage: 'Заменён на service.autofill-background',
    deprecatedRename: 'autofill-background'
  }
};
const feed = {
  'category-neutral': {
    desktopValue: '#90ADBF',
    desktopDarkValue: '#90ADBF',
    iosValue: '#90ADBF',
    iosDarkValue: '#90ADBF',
    androidValue: '#90ADBF',
    androidDarkValue: '#90ADBF',
    comment: 'Для ленты операций в МБ'
  },
  'category-neutral-pale': {
    desktopValue: '#E5ECF4',
    desktopDarkValue: '#2E3036',
    iosValue: '#E5ECF4',
    iosDarkValue: '#2E3036',
    androidValue: '#E5ECF4',
    androidDarkValue: '#2E3036',
    comment: 'Для ленты операций в МБ'
  }
};
const foreground = {
  'neutral-accent': {
    desktopValue: '#00102470',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#00102470',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#00102470',
    androidDarkValue: '#FFFFFF80',
    comment: 'Акцентные элементы на нейтральных фонах',
    deprecated: true,
    deprecatedMessage: 'Перенесен в группу status',
    deprecatedRename: 'neutral'
  },
  'positive-accent': {
    desktopValue: '#00B92D',
    desktopDarkValue: '#00B92D',
    iosValue: '#00B92D',
    iosDarkValue: '#00B92D',
    androidValue: '#00B92D',
    androidDarkValue: '#00B92D',
    comment: 'Акцентные элементы на позитивных нотификациях',
    deprecated: true,
    deprecatedMessage: 'Перенесен в группу status',
    deprecatedRename: 'positive'
  },
  'warning-accent': {
    desktopValue: '#FFCD33',
    desktopDarkValue: '#FFCD33',
    iosValue: '#FFCD33',
    iosDarkValue: '#FFCD33',
    androidValue: '#FFCD33',
    androidDarkValue: '#FFCD33',
    comment: 'Акцентные элементы на предупреждающих нотификациях',
    deprecated: true,
    deprecatedMessage: 'Перенесен в группу status',
    deprecatedRename: 'warning'
  },
  'negative-accent': {
    desktopValue: '#F52222',
    desktopDarkValue: '#F52222',
    iosValue: '#F52222',
    iosDarkValue: '#F52222',
    androidValue: '#F52222',
    androidDarkValue: '#F52222',
    comment: 'Акцентные элементы на негативных нотификациях',
    deprecated: true,
    deprecatedMessage: 'Перенесен в группу status',
    deprecatedRename: 'negative'
  },
  'info-accent': {
    desktopValue: '#428BF9',
    desktopDarkValue: '#428BF9',
    iosValue: '#428BF9',
    iosDarkValue: '#428BF9',
    androidValue: '#428BF9',
    androidDarkValue: '#428BF9',
    comment: 'Акцентные элементы на информационных нотификациях',
    deprecated: true,
    deprecatedMessage: 'Перенесен в группу status',
    deprecatedRename: 'info'
  },
  'on-light': {
    desktopValue: '#000000',
    desktopDarkValue: '#000000',
    iosValue: '#000000',
    iosDarkValue: '#000000',
    androidValue: '#000000',
    androidDarkValue: '#000000',
    comment: 'Акцентные элементы на светлых фонах',
    deprecated: true,
    deprecatedMessage: 'Заменен на accent-on-dark',
    deprecatedRename: 'accent-on-light'
  },
  'on-dark': {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#FFFFFF',
    iosValue: '#FFFFFF',
    iosDarkValue: '#FFFFFF',
    androidValue: '#FFFFFF',
    androidDarkValue: '#FFFFFF',
    comment: 'Акцентные элементы на темных фонах',
    deprecated: true,
    deprecatedMessage: 'Заменен на accent-on-dark',
    deprecatedRename: 'accent-on-dark'
  },
  'brand-tinkoff-accent': {
    desktopValue: '#FFDD2D',
    desktopDarkValue: '#FFDD2D',
    iosValue: '#FFDD2D',
    iosDarkValue: '#FFDD2D',
    androidValue: '#FFDD2D',
    androidDarkValue: '#FFDD2D',
    comment: 'Лоадеры, мелкие бейджи-точки',
    deprecated: true,
    deprecatedMessage: 'Перенесен в отдельную группу',
    deprecatedRename: 'tinkoff'
  },
  skeleton: {
    desktopValue: '#00000008',
    desktopDarkValue: '#FFFFFF1A',
    iosValue: '#00000008',
    iosDarkValue: '#FFFFFF1A',
    androidValue: '#00000008',
    androidDarkValue: '#FFFFFF1A',
    deprecated: true,
    deprecatedMessage: 'Перенесен в отдельную группу',
    deprecatedRename: 'skeleton'
  },
  separator: {
    desktopValue: '#00000036',
    desktopDarkValue: '#FFFFFF33',
    iosValue: '#00000036',
    iosDarkValue: '#FFFFFF33',
    androidValue: '#00000036',
    androidDarkValue: '#FFFFFF33',
    comment: 'Линейки на основных фонах',
    deprecated: true,
    deprecatedMessage: 'Перенесен в отдельную группу',
    deprecatedRename: 'normal'
  },
  'border-darkmode': {
    desktopValue: '#00000000',
    desktopDarkValue: '#FFFFFF1A',
    iosValue: '#00000000',
    iosDarkValue: '#FFFFFF1A',
    androidValue: '#00000000',
    androidDarkValue: '#FFFFFF1A',
    comment: 'Обводка, отделяющая цветные элементы от фона в темной теме',
    deprecated: true,
    deprecatedMessage: 'Перенесен в отдельную группу',
    deprecatedRename: 'darkmode-only'
  },
  'border-on-light': {
    desktopValue: '#00000008',
    desktopDarkValue: '#00000008',
    iosValue: '#00000008',
    iosDarkValue: '#00000008',
    androidValue: '#00000008',
    androidDarkValue: '#00000008',
    comment: 'Обводка, отделяющая цветные элементы от светлого фонов',
    deprecated: true,
    deprecatedMessage: 'Перенесен в отдельную группу',
    deprecatedRename: 'on-light'
  },
  'border-on-dark': {
    desktopValue: '#FFFFFF1A',
    desktopDarkValue: '#FFFFFF1A',
    iosValue: '#FFFFFF1A',
    iosDarkValue: '#FFFFFF1A',
    androidValue: '#FFFFFF1A',
    androidDarkValue: '#FFFFFF1A',
    comment: 'Обводка, отделяющая цветные элементы от темных фонов',
    deprecated: true,
    deprecatedMessage: 'Перенесен в отдельную группу',
    deprecatedRename: 'on-dark'
  }
};
const icon = {
  pressed: {
    desktopValue: '#000000CC',
    desktopDarkValue: '#FFFFFFE6',
    iosValue: '#333333',
    iosDarkValue: '#F6F7F8',
    androidValue: '#333333',
    androidDarkValue: '#F6F7F8',
    comment: 'Текст на фонах base, elevation, neutral',
    deprecated: true,
    deprecatedMessage: 'Для иконок используем цвета из группы text',
    deprecatedRename: 'primary'
  },
  hover: {
    desktopValue: '#0000007A',
    desktopDarkValue: '#FFFFFFB3',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Второстепенный текст на фонах base, elevation, neutral',
    deprecated: true,
    deprecatedMessage: 'Для иконок используем цвета из группы text',
    deprecatedRename: 'secondary'
  },
  normal: {
    desktopValue: '#9299A2',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#00102438',
    iosDarkValue: '#FFFFFF4D',
    androidValue: '#00102438',
    androidDarkValue: '#FFFFFF4D',
    comment: 'Лейблы задизейбленных кнопок, плейсхолдер в текстовых полях, дисклеймеры',
    deprecated: true,
    deprecatedMessage: 'Для иконок используем цвета из группы text',
    deprecatedRename: 'tertiary'
  },
  action: {
    desktopValue: '#126DF7',
    desktopDarkValue: '#6BA4FA',
    iosValue: '#428BF9',
    iosDarkValue: '#428BF9',
    androidValue: '#428BF9',
    androidDarkValue: '#428BF9',
    comment: 'Текст и иконки интерактивного текста на фонах base, elevation и neutral. Заменяет цвет engaging и accent',
    deprecated: true,
    deprecatedMessage: 'Для иконок используем цвета из группы text',
    deprecatedRename: 'action'
  },
  'action-hover': {
    desktopValue: '#1455B8',
    desktopDarkValue: '#428BF9',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Состояние текста при наведении',
    deprecated: true,
    deprecatedMessage: 'Для иконок используем цвета из группы text',
    deprecatedRename: 'action-hover'
  },
  'action-pressed': {
    desktopValue: '#2B4976',
    desktopDarkValue: '#126DF7',
    iosValue: '#156ED4',
    iosDarkValue: '#156ED4',
    androidValue: '#156ED4',
    androidDarkValue: '#156ED4',
    comment: 'Нажатое состояние интерактивной иконки',
    deprecated: true,
    deprecatedMessage: 'Для иконок используем цвета из группы text',
    deprecatedRename: 'action-pressed'
  },
  'on-dark': {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#FFFFFF',
    iosValue: '#FFFFFF',
    iosDarkValue: '#FFFFFF',
    androidValue: '#FFFFFF',
    androidDarkValue: '#FFFFFF',
    comment: 'Иконка на темных фонах. Не меняется при смене темы',
    deprecated: true,
    deprecatedMessage: 'Для иконок используем цвета из группы text',
    deprecatedRename: 'primary-on-dark'
  }
};
const service = {
  'autofill-background': {
    desktopValue: '#FFF5C2',
    desktopDarkValue: '#614F23',
    iosValue: '#FFF5C2',
    iosDarkValue: '#614F23',
    androidValue: '#FFF5C2',
    androidDarkValue: '#614F23',
    comment: 'Цвет фона при автозаполнении форм'
  },
  skeleton: {
    desktopValue: '#0000000f',
    desktopDarkValue: '#FFFFFF1A',
    iosValue: '#00000008',
    iosDarkValue: '#FFFFFF1A',
    androidValue: '#00000008',
    androidDarkValue: '#FFFFFF1A',
    comment: 'Цвет для шиммеров, отображаемых при загрузке экрана'
  },
  'skeleton-on-dark': {
    desktopValue: '#FFFFFF26',
    desktopDarkValue: '#FFFFFF26',
    iosValue: '#FFFFFF26',
    iosDarkValue: '#FFFFFF26',
    androidValue: '#FFFFFF26',
    androidDarkValue: '#FFFFFF26',
    comment: 'Скелетон на темном фоне, не меняется при переключении темы'
  },
  'selected-text': {
    desktopValue: '#428BF93D',
    desktopDarkValue: '#428BF93D',
    iosValue: '#428BF93D',
    iosDarkValue: '#428BF93D',
    androidValue: '#428BF93D',
    androidDarkValue: '#428BF93D',
    comment: 'Фон под выделенным пользователем текстом',
    deprecated: true,
    deprecatedMessage: 'Заменён на service.selection-background',
    deprecatedRename: 'selection-background'
  },
  'selection-background': {
    desktopValue: '#428BF93D',
    desktopDarkValue: '#428BF93D',
    iosValue: '#428BF93D',
    iosDarkValue: '#428BF93D',
    androidValue: '#428BF93D',
    androidDarkValue: '#428BF93D',
    comment: 'Фон при выделении текста и изображений'
  },
  'highlight-background': {
    desktopValue: '#FFDD2D52',
    desktopDarkValue: '#FFDD2D52',
    iosValue: '#FFDD2D52',
    iosDarkValue: '#FFDD2D52',
    androidValue: '#FFDD2D52',
    androidDarkValue: '#FFDD2D52',
    comment: 'Фон под выделенным текстом'
  },
  ripple: {
    desktopValue: null,
    desktopDarkValue: null,
    iosValue: null,
    iosDarkValue: null,
    androidValue: '#0000000A',
    androidDarkValue: '#ffffff0F',
    comment: 'Только для android. Риппл-эффект для элементов с фонами base, elevation, neutral, engaging'
  },
  'ripple-on-light': {
    desktopValue: null,
    desktopDarkValue: null,
    iosValue: null,
    iosDarkValue: null,
    androidValue: '#0000000A',
    androidDarkValue: '#0000000A',
    comment: 'Только для android. Риппл-эффект для элементов с цветными светлыми фонами'
  },
  'ripple-on-dark': {
    desktopValue: null,
    desktopDarkValue: null,
    iosValue: null,
    iosDarkValue: null,
    androidValue: '#ffffff21',
    androidDarkValue: '#ffffff21',
    comment: 'Только для android. Риппл-эффект для элементов с цветными темными фонами'
  },
  'ripple-on-opposite': {
    desktopValue: null,
    desktopDarkValue: null,
    iosValue: null,
    iosDarkValue: null,
    androidValue: '#ffffff21',
    androidDarkValue: '#0000000f',
    comment: 'Только для android. Риппл-эффект для элементов с фоном opposite'
  },
  'ripple-on-tinkoff': {
    desktopValue: null,
    desktopDarkValue: null,
    iosValue: null,
    iosDarkValue: null,
    androidValue: '#FAB61966',
    androidDarkValue: '#FAB61966',
    comment: 'Только для android. Риппл на фонах с цветом tinkoff'
  },
  backdrop: {
    desktopValue: '#000000B3',
    desktopDarkValue: '#000000B3',
    iosValue: '#00000080',
    iosDarkValue: '#00000080',
    androidValue: '#00000080',
    androidDarkValue: '#00000080',
    comment: 'Затемнение на фоне модальных окон и шторок'
  },
  underline: {
    desktopValue: '#97BFFC',
    desktopDarkValue: '#5798FA',
    iosValue: '#97BFFC',
    iosDarkValue: '#5798FA',
    androidValue: '#97BFFC',
    androidDarkValue: '#5798FA',
    comment: 'Подчеркивание для ссылок'
  },
  'underline-hover': {
    desktopValue: '#156ED4',
    desktopDarkValue: '#126DF7',
    iosValue: '#156ED4',
    iosDarkValue: '#126DF7',
    androidValue: '#156ED4',
    androidDarkValue: '#126DF7',
    comment: 'Подчеркивание для ссылок'
  },
  'underline-pressed': {
    desktopValue: '#156ED4',
    desktopDarkValue: '#156ED4',
    iosValue: '#7FB0FB',
    iosDarkValue: '#7FB0FB',
    androidValue: '#7FB0FB',
    androidDarkValue: '#7FB0FB',
    comment: 'Подчеркивание для ссылок'
  },
  'underline-grayscale': {
    desktopValue: '#00000052',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#9299A2',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#9299A2',
    androidDarkValue: '#FFFFFF80',
    comment: 'Подчеркивание для монохромных ссылок'
  },
  'underline-grayscale-hover': {
    desktopValue: '#000000CC',
    desktopDarkValue: '#FFFFFFE6',
    iosValue: '#000000CC',
    iosDarkValue: '#FFFFFFE6',
    androidValue: '#000000CC',
    androidDarkValue: '#FFFFFFE6',
    comment: 'Подчеркивание для монохромных ссылок'
  },
  'underline-grayscale-pressed': {
    desktopValue: '#00000066',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#9299A2',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#9299A2',
    androidDarkValue: '#FFFFFF80',
    comment: 'Подчеркивание для монохромных ссылок'
  },
  'underline-grayscale-on-dark': {
    desktopValue: '#FFFFFF80',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#FFFFFF80',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#FFFFFF80',
    androidDarkValue: '#FFFFFF80',
    comment: 'Подчеркивание для монохромных ссылок на тёмных фонах, не меняется при смене темы'
  },
  'underline-grayscale-on-dark-hover': {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#FFFFFF',
    iosValue: '#FFFFFF',
    iosDarkValue: '#FFFFFF',
    androidValue: '#FFFFFF',
    androidDarkValue: '#FFFFFF',
    comment: 'Подчеркивание для монохромных ссылок на тёмных фонах, не меняется при смене темы'
  },
  'underline-grayscale-on-dark-pressed': {
    desktopValue: '#FFFFFF80',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#FFFFFF80',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#FFFFFF80',
    androidDarkValue: '#FFFFFF80',
    comment: 'Подчеркивание для монохромных ссылок на тёмных фонах, не меняется при смене темы'
  },
  'underline-grayscale-on-light': {
    desktopValue: '#00000052',
    desktopDarkValue: '#00000052',
    iosValue: '#00000052',
    iosDarkValue: '#00000052',
    androidValue: '#00000052',
    androidDarkValue: '#00000052',
    comment: 'Подчеркивание для монохромных ссылок на светлых фонах, не меняется при смене темы'
  },
  'underline-grayscale-on-light-hover': {
    desktopValue: '#000000CC',
    desktopDarkValue: '#000000CC',
    iosValue: '#000000CC',
    iosDarkValue: '#000000CC',
    androidValue: '#000000CC',
    androidDarkValue: '#000000CC',
    comment: 'Подчеркивание для монохромных ссылок на светлых фонах, не меняется при смене темы'
  },
  'underline-grayscale-on-light-pressed': {
    desktopValue: '#00000066',
    desktopDarkValue: '#00000066',
    iosValue: '#00000066',
    iosDarkValue: '#00000066',
    androidValue: '#00000066',
    androidDarkValue: '#00000066',
    comment: 'Подчеркивание для монохромных ссылок на светлых фонах, не меняется при смене темы'
  },
  'underline-monochrome': {
    desktopValue: '#0000003D',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#0000003D',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#0000003D',
    androidDarkValue: '#FFFFFF80',
    comment: 'Подчеркивание для монохромных ссылок',
    deprecated: true,
    deprecatedMessage: 'Заменён на цвет underline-grayscale',
    deprecatedRename: 'underline-grayscale'
  },
  'underline-on-dark': {
    desktopValue: '#FFFFFF80',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#FFFFFF80',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#FFFFFF80',
    androidDarkValue: '#FFFFFF80',
    comment: 'Подчеркивание для монохромных ссылок на темном фоне. Не меняется при смене темы',
    deprecated: true,
    deprecatedMessage: 'Заменён на цвет underline-grayscale-on-dark',
    deprecatedRename: 'underline-grayscale-on-dark'
  },
  'link-visited': {
    desktopValue: '#8B4EA6',
    desktopDarkValue: '#D08FFF',
    iosValue: '#8B4EA6',
    iosDarkValue: '#D08FFF',
    androidValue: '#8B4EA6',
    androidDarkValue: '#D08FFF',
    comment: 'Цвет для ссылок, открывшихся в прошлом'
  },
  'link-on-dark-visited': {
    desktopValue: '#D08FFF',
    desktopDarkValue: '#D08FFF',
    iosValue: '#D08FFF',
    iosDarkValue: '#D08FFF',
    androidValue: '#D08FFF',
    androidDarkValue: '#D08FFF',
    comment: 'Цвет для ссылок на тёмных фонах, открывшихся в прошлом'
  },
  'link-on-light-visited': {
    desktopValue: '#8B4EA6',
    desktopDarkValue: '#8B4EA6',
    iosValue: '#8B4EA6',
    iosDarkValue: '#8B4EA6',
    androidValue: '#8B4EA6',
    androidDarkValue: '#8B4EA6',
    comment: 'Цвет для ссылок на светлых фонах, открывшихся в прошлом'
  }
};
const status = {
  'warning-pale': {
    desktopValue: '#FFDD2D3D',
    desktopDarkValue: '#503C18',
    iosValue: '#FFDD2D4D',
    iosDarkValue: '#503C18',
    androidValue: '#FFDD2D4D',
    androidDarkValue: '#503C18',
    comment: 'Контейнеры предупреждающих блоков'
  },
  'warning-pale-hover': {
    desktopValue: '#FFDD2D66',
    desktopDarkValue: '#806925',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Контейнеры предупреждающих блоков при наведении'
  },
  'warning-pale-pressed': {
    desktopValue: '#FFDD2D7A',
    desktopDarkValue: '#806925',
    iosValue: '#FFDD2D7A',
    iosDarkValue: '#806925',
    androidValue: '#FFDD2D7A',
    androidDarkValue: '#806925',
    comment: 'Нажатое состояние контейнера предупреждающих блоков'
  },
  'warning-pale-on-dark': {
    desktopValue: '#FFDD2D3D',
    desktopDarkValue: '#FFDD2D3D',
    iosValue: '#FFDD2D3D',
    iosDarkValue: '#FFDD2D3D',
    androidValue: '#FFDD2D3D',
    androidDarkValue: '#FFDD2D3D',
    comment: 'Контейнеры предупреждающих блоков на тёмных фонах'
  },
  'warning-pale-on-dark-hover': {
    desktopValue: '#FFDD2D47',
    desktopDarkValue: '#FFDD2D47',
    iosValue: '#FFDD2D47',
    iosDarkValue: '#FFDD2D47',
    androidValue: '#FFDD2D47',
    androidDarkValue: '#FFDD2D47',
    comment: 'Контейнеры предупреждающих блоков на тёмных фонах'
  },
  'warning-pale-on-dark-pressed': {
    desktopValue: '#FFDD2D52',
    desktopDarkValue: '#FFDD2D52',
    iosValue: '#FFDD2D52',
    iosDarkValue: '#FFDD2D52',
    androidValue: '#FFDD2D52',
    androidDarkValue: '#FFDD2D52',
    comment: 'Контейнеры предупреждающих блоков на тёмных фонах'
  },
  'positive-pale': {
    desktopValue: '#00B92D29',
    desktopDarkValue: '#144823',
    iosValue: '#00B92D29',
    iosDarkValue: '#144823',
    androidValue: '#00B92D29',
    androidDarkValue: '#144823',
    comment: 'Контейнеры позитивных блоков'
  },
  'positive-pale-hover': {
    desktopValue: '#00B92D3D',
    desktopDarkValue: '#115B24',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Контейнеры позитивных блоков при наведении'
  },
  'positive-pale-pressed': {
    desktopValue: '#00B92D52',
    desktopDarkValue: '#115B24',
    iosValue: '#00B92D52',
    iosDarkValue: '#115B24',
    androidValue: '#00B92D52',
    androidDarkValue: '#115B24',
    comment: 'Нажатое состояние positive в iOS'
  },
  'positive-pale-on-dark': {
    desktopValue: '#00B92D52',
    desktopDarkValue: '#00B92D52',
    iosValue: '#00B92D52',
    iosDarkValue: '#00B92D52',
    androidValue: '#00B92D52',
    androidDarkValue: '#00B92D52',
    comment: 'Контейнеры позитивных блоков на тёмных фонах, не меняются от темы'
  },
  'positive-pale-on-dark-hover': {
    desktopValue: '#00B92D61',
    desktopDarkValue: '#00B92D61',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Контейнеры позитивных блоков на тёмных фонах при наведении'
  },
  'positive-pale-on-dark-pressed': {
    desktopValue: '#00B92D70',
    desktopDarkValue: '#00B92D70',
    iosValue: '#00B92D70',
    iosDarkValue: '#00B92D70',
    androidValue: '#00B92D70',
    androidDarkValue: '#00B92D70',
    comment: 'Нажатое состояние positive-on-dark'
  },
  'negative-pale': {
    desktopValue: '#F5222224',
    desktopDarkValue: '#5D2C2D',
    iosValue: '#F5222224',
    iosDarkValue: '#591E20',
    androidValue: '#F5222224',
    androidDarkValue: '#591E20',
    comment: 'Контейнеры негативных блоков'
  },
  'negative-pale-hover': {
    desktopValue: '#F522223D',
    desktopDarkValue: '#731F20',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Контейнеры негативных блоков при наведении'
  },
  'negative-pale-pressed': {
    desktopValue: '#F522223D',
    desktopDarkValue: '#731F20',
    iosValue: '#F522223D',
    iosDarkValue: '#731F20',
    androidValue: '#F522223D',
    androidDarkValue: '#731F20',
    comment: 'Нажатое состояние negative в iOS'
  },
  'negative-pale-on-dark': {
    desktopValue: '#F5222252',
    desktopDarkValue: '#F5222252',
    iosValue: '#F5222252',
    iosDarkValue: '#F5222252',
    androidValue: '#F5222252',
    androidDarkValue: '#F5222252',
    comment: 'Контейнеры негативных блоков на тёмных фонах'
  },
  'negative-pale-on-dark-hover': {
    desktopValue: '#F5222261',
    desktopDarkValue: '#F5222261',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Контейнеры негативных блоков на тёмных фонах при наведении'
  },
  'negative-pale-on-dark-pressed': {
    desktopValue: '#F5222270',
    desktopDarkValue: '#F5222270',
    iosValue: '#F5222270',
    iosDarkValue: '#F5222270',
    androidValue: '#F5222270',
    androidDarkValue: '#F5222270',
    comment: 'Нажатое состояние negative-pale-on-dark'
  },
  'info-pale': {
    desktopValue: '#428BF929',
    desktopDarkValue: '#263B5C',
    iosValue: '#428BF929',
    iosDarkValue: '#263B5C',
    androidValue: '#428BF929',
    androidDarkValue: '#263B5C',
    comment: 'Контейнеры информационных блоков'
  },
  'info-pale-hover': {
    desktopValue: '#428BF93D',
    desktopDarkValue: '#2B4976',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Контейнеры информационных блоков при наведении'
  },
  'info-pale-pressed': {
    desktopValue: '#428BF93D',
    desktopDarkValue: '#2B4976',
    iosValue: '#428BF93D',
    iosDarkValue: '#2B4976',
    androidValue: '#428BF93D',
    androidDarkValue: '#2B4976',
    comment: 'Контейнеры информационных блоков при нажатии'
  },
  'info-pale-on-dark': {
    desktopValue: '#428BF952',
    desktopDarkValue: '#428BF952',
    iosValue: '#428BF952',
    iosDarkValue: '#428BF952',
    androidValue: '#428BF952',
    androidDarkValue: '#428BF952',
    comment: 'Контейнеры информационных блоков на тёмных фонах'
  },
  'info-pale-on-dark-hover': {
    desktopValue: '#428BF961',
    desktopDarkValue: '#428BF961',
    iosValue: '#428BF961',
    iosDarkValue: '#428BF961',
    androidValue: '#428BF961',
    androidDarkValue: '#428BF961',
    comment: 'Контейнеры информационных блоков на тёмных фонах'
  },
  'info-pale-on-dark-pressed': {
    desktopValue: '#428BF970',
    desktopDarkValue: '#428BF970',
    iosValue: '#428BF970',
    iosDarkValue: '#428BF970',
    androidValue: '#428BF970',
    androidDarkValue: '#428BF970',
    comment: 'Контейнеры информационных блоков на тёмных фонах'
  },
  neutral: {
    desktopValue: '#79818C',
    desktopDarkValue: '#959BA4',
    iosValue: '#00102470',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#00102470',
    androidDarkValue: '#FFFFFF80',
    comment: 'Акцентный цвет для нейтральных фонах'
  },
  'neutral-pale': {
    desktopValue: '#00102414',
    desktopDarkValue: '#FFFFFF26',
    iosValue: '#00102414',
    iosDarkValue: '#FFFFFF26',
    androidValue: '#00102414',
    androidDarkValue: '#FFFFFF26',
    comment: 'Фоновый контейнер нейтральных статусных блоков'
  },
  'neutral-pale-hover': {
    desktopValue: '#0010241F',
    desktopDarkValue: '#FFFFFF40',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Фоновый контейнер нейтральных статусных блоков при наведении'
  },
  'neutral-pale-pressed': {
    desktopValue: '#0010242E',
    desktopDarkValue: '#FFFFFF4D',
    iosValue: '#0010242E',
    iosDarkValue: '#FFFFFF4D',
    androidValue: '#0010242E',
    androidDarkValue: '#FFFFFF4D',
    comment: 'Фоновый контейнер нейтральных статусных блоков при нажатии'
  },
  positive: {
    desktopValue: '#00B92D',
    desktopDarkValue: '#038C24',
    iosValue: '#00B92D',
    iosDarkValue: '#00B92D',
    androidValue: '#00B92D',
    androidDarkValue: '#00B92D',
    comment: 'Акцентный цвет для позитивных блоков'
  },
  warning: {
    desktopValue: '#FFCD33',
    desktopDarkValue: '#FFCD33',
    iosValue: '#FFCD33',
    iosDarkValue: '#FFCD33',
    androidValue: '#FFCD33',
    androidDarkValue: '#FFCD33',
    comment: 'Акцентный цвет для предупреждающих блоков'
  },
  negative: {
    desktopValue: '#F52222',
    desktopDarkValue: '#CD2324',
    iosValue: '#F52222',
    iosDarkValue: '#F52222',
    androidValue: '#F52222',
    androidDarkValue: '#F52222',
    comment: 'Акцентный цвет для негативных блоков'
  },
  'negative-hover': {
    desktopValue: '#CD2324',
    desktopDarkValue: '#DA2526',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Акцентный цвет для негативных блоков при наведении'
  },
  'negative-pressed': {
    desktopValue: '#9C0707',
    desktopDarkValue: '#DC3233',
    iosValue: '#9C0707',
    iosDarkValue: '#CD2324',
    androidValue: '#9C0707',
    androidDarkValue: '#CD2324',
    comment: 'Акцентный цвет для негативных блоков при нажатии'
  },
  info: {
    desktopValue: '#428BF9',
    desktopDarkValue: '#156ED4',
    iosValue: '#428BF9',
    iosDarkValue: '#428BF9',
    androidValue: '#428BF9',
    androidDarkValue: '#428BF9',
    comment: 'Акцентный цвет для информационных блоков'
  }
};
const support = {
  'support-01': {
    desktopValue: '#00BEE0',
    desktopDarkValue: '#00BEE0',
    iosValue: '#00BEE0',
    iosDarkValue: '#00BEE0',
    androidValue: '#00BEE0',
    androidDarkValue: '#00BEE0',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-01'
  },
  'support-02': {
    desktopValue: '#9887F1',
    desktopDarkValue: '#9887F1',
    iosValue: '#9887F1',
    iosDarkValue: '#9887F1',
    androidValue: '#9887F1',
    androidDarkValue: '#9887F1',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-02'
  },
  'support-03': {
    desktopValue: '#F94D4D',
    desktopDarkValue: '#F94D4D',
    iosValue: '#F94D4D',
    iosDarkValue: '#F94D4D',
    androidValue: '#F94D4D',
    androidDarkValue: '#F94D4D',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-03'
  },
  'support-04': {
    desktopValue: '#34BFB1',
    desktopDarkValue: '#34BFB1',
    iosValue: '#34BFB1',
    iosDarkValue: '#34BFB1',
    androidValue: '#34BFB1',
    androidDarkValue: '#34BFB1',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-04'
  },
  'support-05': {
    desktopValue: '#FFAD5C',
    desktopDarkValue: '#FFAD5C',
    iosValue: '#FFAD5C',
    iosDarkValue: '#FFAD5C',
    androidValue: '#FFAD5C',
    androidDarkValue: '#FFAD5C',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-05'
  },
  'support-06': {
    desktopValue: '#929DED',
    desktopDarkValue: '#929DED',
    iosValue: '#929DED',
    iosDarkValue: '#929DED',
    androidValue: '#929DED',
    androidDarkValue: '#929DED',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-06'
  },
  'support-07': {
    desktopValue: '#45AD2D',
    desktopDarkValue: '#45AD2D',
    iosValue: '#45AD2D',
    iosDarkValue: '#45AD2D',
    androidValue: '#45AD2D',
    androidDarkValue: '#45AD2D',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-07'
  },
  'support-08': {
    desktopValue: '#3392DB',
    desktopDarkValue: '#3392DB',
    iosValue: '#3392DB',
    iosDarkValue: '#3392DB',
    androidValue: '#3392DB',
    androidDarkValue: '#3392DB',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-08'
  },
  'support-09': {
    desktopValue: '#DF8400',
    desktopDarkValue: '#DF8400',
    iosValue: '#DF8400',
    iosDarkValue: '#DF8400',
    androidValue: '#DF8400',
    androidDarkValue: '#DF8400',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-09'
  },
  'support-10': {
    desktopValue: '#AE59D4',
    desktopDarkValue: '#AE59D4',
    iosValue: '#AE59D4',
    iosDarkValue: '#AE59D4',
    androidValue: '#AE59D4',
    androidDarkValue: '#AE59D4',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-10'
  },
  'support-11': {
    desktopValue: '#FD7171',
    desktopDarkValue: '#FD7171',
    iosValue: '#FD7171',
    iosDarkValue: '#FD7171',
    androidValue: '#FD7171',
    androidDarkValue: '#FD7171',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-11'
  },
  'support-12': {
    desktopValue: '#52BBE1',
    desktopDarkValue: '#52BBE1',
    iosValue: '#52BBE1',
    iosDarkValue: '#52BBE1',
    androidValue: '#52BBE1',
    androidDarkValue: '#52BBE1',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-12'
  },
  'support-13': {
    desktopValue: '#FE9B4B',
    desktopDarkValue: '#FE9B4B',
    iosValue: '#FE9B4B',
    iosDarkValue: '#FE9B4B',
    androidValue: '#FE9B4B',
    androidDarkValue: '#FE9B4B',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-13'
  },
  'support-14': {
    desktopValue: '#BF69F1',
    desktopDarkValue: '#BF69F1',
    iosValue: '#BF69F1',
    iosDarkValue: '#BF69F1',
    androidValue: '#BF69F1',
    androidDarkValue: '#BF69F1',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-14'
  },
  'support-15': {
    desktopValue: '#EC4D6B',
    desktopDarkValue: '#EC4D6B',
    iosValue: '#EC4D6B',
    iosDarkValue: '#EC4D6B',
    androidValue: '#EC4D6B',
    androidDarkValue: '#EC4D6B',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-15'
  },
  'support-16': {
    desktopValue: '#3DAF69',
    desktopDarkValue: '#3DAF69',
    iosValue: '#3DAF69',
    iosDarkValue: '#3DAF69',
    androidValue: '#3DAF69',
    androidDarkValue: '#3DAF69',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-16'
  },
  'support-17': {
    desktopValue: '#FF7047',
    desktopDarkValue: '#FF7047',
    iosValue: '#FF7047',
    iosDarkValue: '#FF7047',
    androidValue: '#FF7047',
    androidDarkValue: '#FF7047',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-17'
  },
  'support-18': {
    desktopValue: '#994ABD',
    desktopDarkValue: '#994ABD',
    iosValue: '#994ABD',
    iosDarkValue: '#994ABD',
    androidValue: '#994ABD',
    androidDarkValue: '#994ABD',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-18'
  },
  'support-19': {
    desktopValue: '#DD4444',
    desktopDarkValue: '#DD4444',
    iosValue: '#DD4444',
    iosDarkValue: '#DD4444',
    androidValue: '#DD4444',
    androidDarkValue: '#DD4444',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-19'
  },
  'support-20': {
    desktopValue: '#36C578',
    desktopDarkValue: '#36C578',
    iosValue: '#36C578',
    iosDarkValue: '#36C578',
    androidValue: '#36C578',
    androidDarkValue: '#36C578',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-20'
  },
  'support-21': {
    desktopValue: '#1DACA4',
    desktopDarkValue: '#1DACA4',
    iosValue: '#1DACA4',
    iosDarkValue: '#1DACA4',
    androidValue: '#1DACA4',
    androidDarkValue: '#1DACA4',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-21'
  },
  'support-22': {
    desktopValue: '#F14789',
    desktopDarkValue: '#F14789',
    iosValue: '#F14789',
    iosDarkValue: '#F14789',
    androidValue: '#F14789',
    androidDarkValue: '#F14789',
    deprecated: true,
    deprecatedMessage: 'Замена на семантические цвета',
    deprecatedRename: 'categorical-22'
  }
};
const text = {
  primary: {
    desktopValue: '#000000CC',
    desktopDarkValue: '#FFFFFFE6',
    iosValue: '#333333',
    iosDarkValue: '#F6F7F8',
    androidValue: '#333333',
    androidDarkValue: '#F6F7F8',
    comment: 'Основной текст и иконки фонах base, elevation, neutral'
  },
  'primary-hover': {
    desktopValue: '#00000080',
    desktopDarkValue: '#FFFFFFB3',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Основной текст и иконки фонах base, elevation, neutral при наведении'
  },
  'primary-pressed': {
    desktopValue: '#00000066',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#575B61',
    iosDarkValue: '#9299A2',
    androidValue: '#575B61',
    androidDarkValue: '#9299A2',
    comment: 'Основной текст и иконки фонах base, elevation, neutral при нажатии'
  },
  'primary-on-light': {
    desktopValue: '#000000CC',
    desktopDarkValue: '#000000CC',
    iosValue: '#333333',
    iosDarkValue: '#333333',
    androidValue: '#333333',
    androidDarkValue: '#333333',
    comment: 'Основной текст и иконки на светлых фонах, не меняется при смене темы'
  },
  'primary-on-light-hover': {
    desktopValue: '#00000080',
    desktopDarkValue: '#00000080',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Основной текст и иконки на светлых фонах, не меняется при смене темы'
  },
  'primary-on-light-pressed': {
    desktopValue: '#00000066',
    desktopDarkValue: '#00000066',
    iosValue: '#999999',
    iosDarkValue: '#999999',
    androidValue: '#999999',
    androidDarkValue: '#999999',
    comment: 'Основной текст и иконки на светлых фонах, не меняется при смене темы'
  },
  'primary-on-dark': {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#FFFFFF',
    iosValue: '#FFFFFF',
    iosDarkValue: '#FFFFFF',
    androidValue: '#FFFFFF',
    androidDarkValue: '#FFFFFF',
    comment: 'Основной текст и иконки темных фонах. Не меняется при смене темы'
  },
  'primary-on-dark-hover': {
    desktopValue: '#FFFFFFB3',
    desktopDarkValue: '#FFFFFFB3',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Основной текст и иконки темных фонах. Не меняется при смене темы'
  },
  'primary-on-dark-pressed': {
    desktopValue: '#FFFFFF80',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#FFFFFF80',
    iosDarkValue: '#FFFFFF80',
    androidValue: '#FFFFFF80',
    androidDarkValue: '#FFFFFF80',
    comment: 'Основной текст и иконки темных фонах. Не меняется при смене темы'
  },
  'primary-on-t-bank': {
    desktopValue: '#333333',
    desktopDarkValue: '#333333',
    iosValue: '#333333',
    iosDarkValue: '#333333',
    androidValue: '#333333',
    androidDarkValue: '#333333',
    comment: 'Текст и иконки на фонах t-bank'
  },
  'primary-on-opposite': {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#000000',
    iosValue: '#FFFFFF',
    iosDarkValue: '#000000',
    androidValue: '#FFFFFF',
    androidDarkValue: '#000000',
    comment: 'Текст и иконки фоне opposite'
  },
  'primary-on-accent-1': {
    desktopValue: '#333333',
    desktopDarkValue: '#333333',
    iosValue: '#333333',
    iosDarkValue: '#333333',
    androidValue: '#333333',
    androidDarkValue: '#333333',
    comment: 'Текст и иконки фоне accent-1'
  },
  'primary-on-accent-2': {
    desktopValue: '#FFFFFF',
    desktopDarkValue: '#FFFFFF',
    iosValue: '#FFFFFF',
    iosDarkValue: '#FFFFFF',
    androidValue: '#FFFFFF',
    androidDarkValue: '#FFFFFF',
    comment: 'Текст и иконки фоне accent-2'
  },
  secondary: {
    desktopValue: '#0000008A',
    desktopDarkValue: '#FFFFFFB3',
    iosValue: '#9299A2',
    iosDarkValue: '#9299A2',
    androidValue: '#9299A2',
    androidDarkValue: '#9299A2',
    comment: 'Второстепенный текст на фонах base, elevation, neutral'
  },
  'secondary-hover': {
    desktopValue: '#000000B3',
    desktopDarkValue: '#FFFFFFCC',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Второстепенный текст на фонах base, elevation, neutral при наведении'
  },
  'secondary-pressed': {
    desktopValue: '#000000E6',
    desktopDarkValue: '#FFFFFFF5',
    iosValue: '#575B61',
    iosDarkValue: '#C7C9CC',
    androidValue: '#575B61',
    androidDarkValue: '#C7C9CC',
    comment: 'Второстепенный текст на фонах base, elevation, neutral при нажатии'
  },
  'secondary-on-light': {
    desktopValue: '#0000007A',
    desktopDarkValue: '#0000007A',
    iosValue: '#0000007A',
    iosDarkValue: '#0000007A',
    androidValue: '#0000007A',
    androidDarkValue: '#0000007A',
    comment: 'Второстепенный текст на светлых фонах, не меняется при смене темы'
  },
  'secondary-on-dark': {
    desktopValue: '#FFFFFFB3',
    desktopDarkValue: '#FFFFFFB3',
    iosValue: '#FFFFFFB3',
    iosDarkValue: '#FFFFFFB3',
    androidValue: '#FFFFFFB3',
    androidDarkValue: '#FFFFFFB3',
    comment: 'Второстепенный текст на темных фонах, не меняется при смене темы'
  },
  tertiary: {
    desktopValue: '#00000066',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#00102438',
    iosDarkValue: '#FFFFFF4D',
    androidValue: '#00102438',
    androidDarkValue: '#FFFFFF4D',
    comment: 'Лейблы задизейбленных кнопок, дисклеймеры'
  },
  'tertiary-hover': {
    desktopValue: '#00000099',
    desktopDarkValue: '#FFFFFFB3',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Лейблы задизейбленных кнопок, дисклеймеры при наведении'
  },
  'tertiary-pressed': {
    desktopValue: '#000000B3',
    desktopDarkValue: '#FFFFFFCC',
    iosValue: '#0010248F',
    iosDarkValue: '#FFFFFF99',
    androidValue: '#0010248F',
    androidDarkValue: '#FFFFFF99',
    comment: 'Лейблы задизейбленных кнопок, дисклеймеры, дисклеймеры при нажатии'
  },
  'tertiary-on-light': {
    desktopValue: '#00000066',
    desktopDarkValue: '#00000066',
    iosValue: '#00102438',
    iosDarkValue: '#00102438',
    androidValue: '#00102438',
    androidDarkValue: '#00102438',
    comment: 'Лейблы задизейбленных кнопок, дисклеймеры на светлых фонах, не меняется при смене темы'
  },
  'tertiary-on-dark': {
    desktopValue: '#FFFFFF80',
    desktopDarkValue: '#FFFFFF80',
    iosValue: '#FFFFFF4D',
    iosDarkValue: '#FFFFFF4D',
    androidValue: '#FFFFFF4D',
    androidDarkValue: '#FFFFFF4D',
    comment: 'Лейблы задизейбленных кнопок, дисклеймеры на светлых фонах, не меняется при смене темы'
  },
  action: {
    desktopValue: '#126DF7',
    desktopDarkValue: '#6BA4FA',
    iosValue: '#428BF9',
    iosDarkValue: '#5798FA',
    androidValue: '#428BF9',
    androidDarkValue: '#5798FA',
    comment: 'Текст и иконки интерактивного текста на фонах base, elevation и neutral. Заменяет цвет engaging и accent'
  },
  'action-hover': {
    desktopValue: '#156ED4',
    desktopDarkValue: '#7FB0FB',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Состояние текста при наведении'
  },
  'action-pressed': {
    desktopValue: '#1455B8',
    desktopDarkValue: '#1455B8',
    iosValue: '#156ED4',
    iosDarkValue: '#156ED4',
    androidValue: '#156ED4',
    androidDarkValue: '#156ED4',
    comment: 'Нажатое состояние интерактивного текста. Заменяет цвет engaging-pressed и accent-pressed'
  },
  'action-on-dark': {
    desktopValue: '#75AAFA',
    desktopDarkValue: '#75AAFA',
    iosValue: '#6BA4FA',
    iosDarkValue: '#6BA4FA',
    androidValue: '#6BA4FA',
    androidDarkValue: '#6BA4FA',
    comment: 'Текст и иконки интерактивного текста на тёмных фонах'
  },
  accent: {
    desktopValue: '#428BF9',
    desktopDarkValue: '#428BF9',
    iosValue: '#428BF9',
    iosDarkValue: '#428BF9',
    androidValue: '#428BF9',
    androidDarkValue: '#428BF9',
    comment: 'Текст и иконки интерактивных элементов на фонах base, elevation и neutral. Заменяет цвет engaging',
    deprecated: true,
    deprecatedMessage: 'Заменён на цвет action',
    deprecatedRename: 'action'
  },
  'accent-pressed': {
    desktopValue: '#156ED4',
    desktopDarkValue: '#156ED4',
    iosValue: '#156ED4',
    iosDarkValue: '#156ED4',
    androidValue: '#156ED4',
    androidDarkValue: '#156ED4',
    comment: 'Нажатое состояние интерактивного текста. Заменяет цвет engaging-pressed',
    deprecated: true,
    deprecatedMessage: 'Заменён на цвет action-pressed',
    deprecatedRename: 'action-pressed'
  },
  engaging: {
    desktopValue: '#428BF9',
    desktopDarkValue: '#428BF9',
    iosValue: '#428BF9',
    iosDarkValue: '#428BF9',
    androidValue: '#428BF9',
    androidDarkValue: '#428BF9',
    comment: 'Текст и иконки интерактивных элементов на фонах base, elevation и neutral',
    deprecated: true,
    deprecatedMessage: 'Заменён на цвет accent',
    deprecatedRename: 'accent'
  },
  'engaging-pressed': {
    desktopValue: '#156ED4',
    desktopDarkValue: '#156ED4',
    iosValue: '#156ED4',
    iosDarkValue: '#156ED4',
    androidValue: '#156ED4',
    androidDarkValue: '#156ED4',
    comment: 'Нажатое состояние текста и иконок с цветом engaging',
    deprecated: true,
    deprecatedMessage: 'Заменён на цвет accent-pressed',
    deprecatedRename: 'accent-pressed'
  },
  positive: {
    desktopValue: '#00A328',
    desktopDarkValue: '#00E037',
    iosValue: '#00B92D',
    iosDarkValue: '#00B92D',
    androidValue: '#00B92D',
    androidDarkValue: '#00B92D',
    comment: 'Текст позитивного лейбла, например пополнение счета или рост цены акций'
  },
  'positive-hover': {
    desktopValue: '#115B24',
    desktopDarkValue: '#00B92D',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Текст позитивного лейбла при нажатии'
  },
  'positive-on-dark': {
    desktopValue: '#00E037',
    desktopDarkValue: '#00E037',
    iosValue: '#00D635',
    iosDarkValue: '#00D635',
    androidValue: '#00D635',
    androidDarkValue: '#00D635',
    comment: 'Текст позитивного лейбла на тёмном фоне, например пополнение счета или рост цены акций'
  },
  negative: {
    desktopValue: '#F52222',
    desktopDarkValue: '#F74646',
    iosValue: '#F52222',
    iosDarkValue: '#F52222',
    androidValue: '#F52222',
    androidDarkValue: '#F52222',
    comment: 'Текст негативного лейбла, например падение цены акций или ошибка'
  },
  'negative-hover': {
    desktopValue: '#9C0707',
    desktopDarkValue: '#F52222',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Только для веба. Текст негативного лейбла при наведении на вебе'
  },
  'negative-on-dark': {
    desktopValue: '#FF6666',
    desktopDarkValue: '#FF6666',
    iosValue: '#FF4D4D',
    iosDarkValue: '#FF4D4D',
    androidValue: '#FF4D4D',
    androidDarkValue: '#FF4D4D',
    comment: 'Текст негативного лейбла на тёмном фоне, например падение цены акций или ошибка'
  },
  warning: {
    desktopValue: '#F49C01',
    desktopDarkValue: '#FAB619',
    iosValue: '#F49C01',
    iosDarkValue: '#FAB619',
    androidValue: '#F49C01',
    androidDarkValue: '#FAB619',
    comment: 'Предупреждающие текст и иконки'
  },
  'warning-hover': {
    desktopValue: '#614F23',
    desktopDarkValue: '#BF8003',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null,
    comment: 'Предупреждающие текст и иконки при наведении на вебе'
  },
  'warning-on-dark': {
    desktopValue: '#FAB619',
    desktopDarkValue: '#FAB619',
    iosValue: '#FAB619',
    iosDarkValue: '#FAB619',
    androidValue: '#FAB619',
    androidDarkValue: '#FAB619',
    comment: 'Предупреждающие текст и иконки на тёмных фонах'
  },
  'primary-on-tinkoff': {
    desktopValue: '#333333',
    desktopDarkValue: '#333333',
    iosValue: '#333333',
    iosDarkValue: '#333333',
    androidValue: '#333333',
    androidDarkValue: '#333333',
    comment: 'Текст и иконки на фонах tinkoff',
    deprecated: true,
    deprecatedMessage: 'Заменён на цвет primary-on-t-bank',
    deprecatedRename: 'primary-on-t-bank'
  }
};
export const color = {
  background,
  border,
  brand,
  chart,
  component,
  feed,
  foreground,
  icon,
  service,
  status,
  support,
  text
};